<!-- 首页 -->
 <!-- pc端 -->
<div class="pcnav">
  <ul>
    <li (click)="goDetails('home','首页')" class="{{this.pages=='home/home'?'active':''}}">首页</li>
    <li class="{{this.pages=='home/ptjj'?'active':''}}" (click)="goDetails('ptjj','平台简介')">平台简介</li>
    <li class="{{this.pages=='home/tztg'?'active':''}}" (click)="goDetails('tztg','通知通告')">通知通告</li>
    <li class="{{this.pages=='home/zxjzjjs'?'active':''}}" (click)="goDetails('zxjzjjs','中心及专家介绍')">中心及专家介绍</li>
    <li class="{{this.pages=='home/hzkp'?'active':''}}" (click)="goDetails('hzkp','患者科普')">患者科普</li>
    <li class="{{this.pages=='home/yjqyjz'?'active':''}}" (click)="goDetails('yjqyjz','研究前沿进展')">研究前沿进展</li>
    <li class="{{this.pages=='home/lcsyjyjjd'?'active':''}}" (click)="goDetails('lcsyjyjjd','临床试验及研究进度')">临床试验及研究进度</li>
    <!-- <li class="{{this.pages=='home/lcsyjyjjd'?'active':''}}" (click)="goDetails('qgdzxqdh','全国多中心启动会议')">会议</li> -->
    <!-- 
      https://www.ildcloud.com/#/home/home
      https://www.ildcloud.com/#/home/ptjj
      https://www.ildcloud.com/#/home/tztg
      https://www.ildcloud.com/#/home/zxjzjjs
      https://www.ildcloud.com/#/home/hzkp
      https://www.ildcloud.com/#/home/yjqyjz
      https://www.ildcloud.com/#/home/lcsyjyjjd
      https://www.ildcloud.com/#/home/zyxz     
    -->
  </ul>
</div>

<!-- h5端 -->
<div class="h5nav">
  <div class="logo">
    <img src="./assets/new/jjzxfbypt_app_ic_menu.png" alt="" (click)="showNav()">
  </div>
  <div class="layer" *ngIf="navShow == true">
    <div (click)="hideNav()">
      <img src="./assets/new/jjzxfbypt_app_menu_guanbi.png" alt="">
    </div>
    <ul>
      <li (click)="goDetails('home','首页')" class="{{this.pages=='home/home'?'active':''}}"><p>首页</p><span>></span></li>
      <li class="{{this.pages=='home/ptjj'?'active':''}}" (click)="goDetails('ptjj','平台简介')"><p>平台简介</p><span>></span></li>
      <li class="{{this.pages=='home/tztg'?'active':''}}" (click)="goDetails('tztg','通知通告')"><p>通知通告</p><span>></span></li>
      <li class="{{this.pages=='home/zxjzjjs'?'active':''}}" (click)="goDetails('zxjzjjs','中心及专家介绍')"><p>中心及专家介绍</p><span>></span></li>
      <li class="{{this.pages=='home/hzkp'?'active':''}}" (click)="goDetails('hzkp','患者科普')"><p>患者科普</p><span>></span></li>
      <li class="{{this.pages=='home/yjqyjz'?'active':''}}" (click)="goDetails('yjqyjz','研究前沿进展')"><p>研究前沿进展</p><span>></span></li>
      <li class="{{this.pages=='home/lcsyjyjjd'?'active':''}}" (click)="goDetails('lcsyjyjjd','临床试验及研究进度')"><p>临床试验及研究进度</p><span>></span></li>
    </ul>
  </div>
</div>

<div class="height50"></div>

<!-- 首页 -->
<div *ngIf="pages == 'home/home'" style="overflow: hidden;" id="top">
  <div class="banner banner2">
    <div id="carouselExample" class="carousel slide" data-ride="carousel">
      <div class="carousel-indicators">
        <button type="button" data-bs-target="#carouselExample" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
        <button type="button" data-bs-target="#carouselExample" data-bs-slide-to="1" aria-label="Slide 2"></button>
        <button type="button" data-bs-target="#carouselExample" data-bs-slide-to="2" aria-label="Slide 3"></button>
      </div>
      <div class="carousel-inner">
        <div class="carousel-item active">
          <img src="./assets/new/jzxfbypt_home_banner1_gai.png" class="d-block" alt="...">
        </div>
        <div class="carousel-item">
          <img src="./assets/new/jzxfbypt_home_banner2_gai.png" class="d-block" alt="...">
        </div>
        <div class="carousel-item">
          <img src="./assets/new/jzxfbypt_home_banner3_gai.png" class="d-block" alt="...">
        </div>
      </div>
      <button class="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
    <!-- <div>
      <img src="./assets/new/jzxfbypt_home_tittle.png" alt="">
    </div> -->
    <div class="banner-zw"></div>
  </div>

  <div class="module-1 jzxfb-con">
    <div class="title">
      <img src="./assets/new/jzxfbypt_home_ptjj.png" alt="">
      <img src="./assets/new/jzxfbypt_ptjj_ild_cloud.png" alt="">
    </div>
    <div class="content">
      <span class="jzxfb">间质性肺病（Interstitial Lung Disease, ILD）</span>是一组以肺间质炎症和纤维化为主要特征的慢性异质性疾病，包括特发性肺纤维化（IPF）、结节病、过敏性肺炎等多个亚型。流行病学资料显示，ILD的发病率和患病率正逐年上升，治疗手段有限，对患者生活质量和预后造成严重负担。然而，国内在ILD领域的关注度和规范化诊治水平仍不及其他常见呼吸系统疾病，目前缺乏完善的循证医学证据和统一的病例管理体系，尤其缺少针对中国ILD人群的大规模流行病学与真实世界数据。因此，亟需建立一个覆盖全国的ILD临床与科研平台，以推动标准化诊治、多中心协作研究以及临床诊断试剂和新药研发。
      <div class="ljgd" (click)="goDetails('ptjj','平台简介')">查看详情 >></div>
    </div>
  </div>
  <div class="bgfff pt-3" style="display: none;">
    <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
      <div class="carousel-indicators">
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
      </div>
      <div class="carousel-inner">
        <div class="carousel-item active">
          <img src="./assets/new/jzxfbypt_home_huiyi.png" class="d-block w-100" alt="...">
        </div>
        <div class="carousel-item">
          <img src="./assets/new/jzxfbypt_home_huiyi.png" class="d-block w-100" alt="...">
        </div>
        <div class="carousel-item">
          <img src="./assets/new/jzxfbypt_home_huiyi.png" class="d-block w-100" alt="...">
        </div>
      </div>
      <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
  </div>

  <div class="module-2" style="display: none;">
    <div>
      <div>
        <img src="./assets/new/jzxfbypt_home_01.png" alt="">
        <p>平台信息</p>
      </div>
      <div>
        <img src="./assets/new/jzxfbypt_home_02.png" alt="">
        <p>中心专家介绍</p>
      </div>
      <div>
        <img src="./assets/new/jzxfbypt_home_03.png" alt="">
        <p>患者教育</p>
      </div>
      <div>
        <img src="./assets/new/jzxfbypt_home_04.png" alt="">
        <p>研究进展</p>
      </div>
      <div>
        <img src="./assets/new/jzxfbypt_home_05.png" alt="">
        <p>临床试验</p>
      </div>
    </div>
  </div>

  <div class="module-1 module-8">
      <div class="title">
        <img class="widthB50" src="./assets/new/jzxfbypt_home_tztg.png" alt="">
      </div>

      <div class="list pt-3" style="display: none;">
        <div>
          <img src="./assets/new/jzxfbypt_tztg_ic_tubiao.png" alt="">
          <div class="flex1">xxxxxxxxxxxxxxxxxx，xxxxxxxxxxxxxxxxxxxxxx，xxxxxxxxxxxxxxx</div>
          <p>2025-08-31</p>
        </div>
        <div>
          <img src="./assets/new/jzxfbypt_tztg_ic_tubiao.png" alt="">
          <div class="flex1">xxxxxxxxxxxxxxxxxx，xxxxxxxxxxxxxxxxxxxxxx，xxxxxxxxxxxxxxx</div>
          <p>2025-08-31</p>
        </div>
        <div>
          <img src="./assets/new/jzxfbypt_tztg_ic_tubiao.png" alt="">
          <div class="flex1">xxxxxxxxxxxxxxxxxx，xxxxxxxxxxxxxxxxxxxxxx，xxxxxxxxxxxxxxx</div>
          <p>2025-08-31</p>
        </div>
      </div>
      <div style="display: none;" class="more" (click)="goDetails('tztg','通知通告')">查看详情 >></div>
      
      <div style="text-align: center; padding: 30px;">暂无内容</div>
  </div>

  <!-- pc端 -->
  <div class="module-1 module-3 pcend">
    <div class="title">
      <img src="./assets/new/jzxfbypt_home_zxjzjjs.png" alt="">
    </div>
    
    <div id="carouselExampleIndicators2" class="carousel slide" style="display: none;">
      <div class="carousel-indicators">
        <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
        <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="1" aria-label="Slide 2"></button>
        <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="2" aria-label="Slide 3"></button>
      </div>
      <div class="carousel-inner">
        <div class="carousel-item active">
          <img src="./assets/new/jzxfbypt_home_zxjzjjs_xhyy.png" class="d-block w-100" alt="...">
        </div>
        <div class="carousel-item">
          <img src="./assets/new/jzxfbypt_home_zxjzjjs_xhyy.png" class="d-block w-100" alt="...">
        </div>
        <div class="carousel-item">
          <img src="./assets/new/jzxfbypt_home_zxjzjjs_xhyy.png" class="d-block w-100" alt="...">
        </div>
      </div>
      <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>    

    <div id="carouselExampleIndicators3" class="carousel slide">
        <div class="carousel-indicators">
          <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
          <!-- <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="1" aria-label="Slide 2"></button>
          <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="2" aria-label="Slide 3"></button> -->
        </div>
        <div class="carousel-inner">
          <div class="carousel-item active">
            <div class="study-list zjxxs">
              <div class="widthB20 cursor-pointer" (click)="goDetails('zjxx1','专家信息')">
                <img src="./assets/new/jzxfbypt_zxjzjjs_xzj.png" width="150" class="d-block mb-2" alt="...">
                <div class="text-center">
                  <h5 class="colorfff">徐作军</h5>
                  <p class="colorfff">北京协和医院</p>
                </div>
              </div> 
              <div class="widthB20">                
                <img src="./assets/new/jzxfbypt_zxjzjjs_xzj2.png" width="150" class="d-block mb-2" alt="...">
              </div>
              <div class="widthB20">                
                <img src="./assets/new/jzxfbypt_zxjzjjs_xzj2.png" width="150" class="d-block mb-2" alt="...">
              </div>
              <div class="widthB20">                
                <img src="./assets/new/jzxfbypt_zxjzjjs_xzj2.png" width="150" class="d-block mb-2" alt="...">
              </div>
              <!-- <div class="widthB20" (click)="goDetails('zjxx2','专家信息')">
                <img src="./assets/new/jzxfbypt_zxjzjjs_hh.png" width="150" class="d-block mb-2" alt="...">
                <div class="text-center">
                  <h5 class="colorfff">黄慧</h5>
                  <p class="colorfff">北京协和医院</p>
                </div>
              </div> 
              <div class="widthB20" (click)="goDetails('zjxx3','专家信息')">
                <img src="./assets/new/jzxfbypt_zxjzjjs_wp.png" width="150" class="d-block mb-2" alt="...">
                <div class="text-center">
                  <h5 class="colorfff">王平</h5>
                  <p class="colorfff">北京协和医院</p>
                </div>
              </div> 
              <div class="widthB20" (click)="goDetails('zjxx4','专家信息')">
                <img src="./assets/new/jzxfbypt_zxjzjjs_sc.png" width="150" class="d-block mb-2" alt="...">
                <div class="text-center">
                  <h5 class="colorfff">邵池</h5>
                  <p class="colorfff">北京协和医院</p>
                </div>
              </div>  -->
            </div>
          </div>
          <!-- <div class="carousel-item" style="display: none;">  
            <div class="d-flex study-list zjxxs">
              <div class="widthB20" (click)="goDetails('zjxx','专家信息')">
                <img src="./assets/xzj.jpg" width="150" class="d-block mb-2" alt="...">
                <div class="text-center">
                  <h5 class="colorfff">张医生4</h5>
                  <p class="colorfff">北京协和医院</p>
                </div>
              </div>
              <div class="widthB20" (click)="goDetails('zjxx','专家信息')">
                <img src="./assets/xzj.jpg" width="150" class="d-block mb-2" alt="...">
                <div class="text-center">
                  <h5 class="colorfff">张医生4</h5>
                  <p class="colorfff">北京协和医院</p>
                </div>
              </div>
              <div class="widthB20" (click)="goDetails('zjxx','专家信息')">
                <img src="./assets/xzj.jpg" width="150" class="d-block mb-2" alt="...">
                <div class="text-center">
                  <h5 class="colorfff">张医生4</h5>
                  <p class="colorfff">北京协和医院</p>
                </div>
              </div>
              <div class="widthB20" (click)="goDetails('zjxx','专家信息')">
                <img src="./assets/xzj.jpg" width="150" class="d-block mb-2" alt="...">
                <div class="text-center">
                  <h5 class="colorfff">张医生4</h5>
                  <p class="colorfff">北京协和医院</p>
                </div>
              </div>
              <div class="widthB20" (click)="goDetails('zjxx','专家信息')">
                <img src="./assets/xzj.jpg" width="150" class="d-block mb-2" alt="...">
                <div class="text-center">
                  <h5 class="colorfff">张医生4</h5>
                  <p class="colorfff">北京协和医院</p>
                </div>
              </div>
            </div>
          </div>
          <div class="carousel-item" style="display: none;">            
            <div class="d-flex study-list zjxxs">
              <div class="widthB20" (click)="goDetails('zjxx','专家信息')">
                <img src="./assets/xzj.jpg" width="150" class="d-block mb-2" alt="...">
                <div class="text-center">
                  <h5 class="colorfff">张医生5</h5>
                  <p class="colorfff">北京协和医院</p>
                </div>
              </div>
              <div class="widthB20" (click)="goDetails('zjxx','专家信息')">
                <img src="./assets/xzj.jpg" width="150" class="d-block mb-2" alt="...">
                <div class="text-center">
                  <h5 class="colorfff">张医生4</h5>
                  <p class="colorfff">北京协和医院</p>
                </div>
              </div>
              <div class="widthB20" (click)="goDetails('zjxx','专家信息')">
                <img src="./assets/xzj.jpg" width="150" class="d-block mb-2" alt="...">
                <div class="text-center">
                  <h5 class="colorfff">张医生4</h5>
                  <p class="colorfff">北京协和医院</p>
                </div>
              </div>
              <div class="widthB20" (click)="goDetails('zjxx','专家信息')">
                <img src="./assets/xzj.jpg" width="150" class="d-block mb-2" alt="...">
                <div class="text-center">
                  <h5 class="colorfff">张医生4</h5>
                  <p class="colorfff">北京协和医院</p>
                </div>
              </div>
              <div class="widthB20" (click)="goDetails('zjxx','专家信息')">
                <img src="./assets/xzj.jpg" width="150" class="d-block mb-2" alt="...">
                <div class="text-center">
                  <h5 class="colorfff">张医生4</h5>
                  <p class="colorfff">北京协和医院</p>
                </div>
              </div>
            </div>
          </div> -->
        </div>
        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
    </div>

  </div>

  <!-- h5移动端 -->
  <div class="h5end">
    <div class="title">
      <img src="./assets/new/jjzxfbypt_app_zxyjz_tittle.png" alt="">
    </div>
    <div id="carouselExampleIndicators8" class="carousel slide">
      <div class="carousel-indicators">
        <button type="button" data-bs-target="#carouselExampleIndicators8" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
        <!-- <button type="button" data-bs-target="#carouselExampleIndicators8" data-bs-slide-to="1" aria-label="Slide 2"></button>
        <button type="button" data-bs-target="#carouselExampleIndicators8" data-bs-slide-to="2" aria-label="Slide 3"></button> -->
      </div>
      <div class="carousel-inner">
        <div class="carousel-item active" (click)="goDetails('zjxx1','专家信息')">
          <img src="./assets/new/jzxfbypt_zxjzjjs_xzj.png" class="d-block" alt="...">
          <div class="font-bold">徐作军</div>
          <div>北京协和医院</div>
        </div>
        <!-- <div class="carousel-item">
          <img src="./assets/new/jzxfbypt_zxjzjjs_xzj.png" class="d-block" alt="...">
          <div class="font-bold">徐作军</div>
          <div>北京协和医院</div>
        </div>
        <div class="carousel-item">
          <img src="./assets/new/jzxfbypt_zxjzjjs_xzj.png" class="d-block" alt="...">
          <div class="font-bold">徐作军</div>
          <div>北京协和医院</div>
        </div> -->
      </div>
      <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators8" data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators8" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
    
  </div>


  <div class="module-1 module-4">
    <div class="title">
      <img src="./assets/new/jzxfbypt_home_hzkp.png" alt="">
    </div>
    <div class="video">
      <div class="cursor-pointer" (click)="goDetails('hzkpxq1','患者科普')">
        <div><img src="./assets/new/jzxfbypt_home_hzkp_kesou.png" alt=""></div>
        <div>当咳嗽不再只是症状：<br>间质性肺疾病患者如何从声音中读懂病情变化</div>
      </div>
      <div class="cursor-pointer" (click)="goDetails('hzkpxq2','患者科普')">
        <div><img src="./assets/new/jzxfbypt_home_hzkp_tips.png" alt=""></div>
        <div>间质性肺病患者就诊小贴示</div>
      </div>
    </div>
  </div>

  <!-- pc端-研究前沿进展 -->
  <div class="module-1 module-5 pcshow">
    <div class="title">
      <img class="widthB60" src="./assets/new/jzxfbypt_home_yjqyjz.png" alt="">
    </div>    
    <div class="yjqyjz-box">
      <div id="carouselExampleIndicators5" class="carousel slide">
          <div class="carousel-indicators">
            <button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
            <button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="1" aria-label="Slide 2"></button>
            <!-- <button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="2" aria-label="Slide 3"></button> -->
          </div>
          <div class="carousel-inner">
            <div class="carousel-item active">
              <div class="study-list">
                <div class="widthB33 cursor-pointer" (click)="goDetails('yjqyjzxq1','研究前沿进展')">
                  <img src="./assets/new/jzxfbypt_home_yjqyjz_kesou.png" width="150" class="d-block mb-2" alt="...">
                  <div>
                    <h5>咳嗽在间质性肺疾病中的临床意义与管理进展</h5>
                  </div>
                </div>
                <div class="widthB33 cursor-pointer" (click)="goDetails('yjqyjzxq2','研究前沿进展')">
                  <img src="./assets/new/jzxfbypt_home_yjqyjz_jzxfjbyjjz.png" width="150" class="d-block mb-2" alt="...">
                  <div>
                    <h5>间质性肺疾病研究进展</h5>
                  </div>
                </div> 
                <div class="widthB33 cursor-pointer" (click)="goDetails('yjqyjzxq3','研究前沿进展')">
                  <img src="./assets/new/jzxfbypt_home_yjqyjz_xtxzsmyjczl.png" width="150" class="d-block mb-2" alt="...">
                  <div>
                    <h5>系统性自身免疫性风湿病患者间质性肺疾病的筛查与监测和治疗</h5>
                  </div>
                </div> 
              </div>
            </div>
            <div class="carousel-item">  
              <div class="d-flex study-list">
                <div class="widthB33 cursor-pointer" (click)="goDetails('yjqyjzxq4','研究前沿进展')">
                  <img src="./assets/new/jzxfbypt_home_yjqyjz_zpzqljhgf.png" width="150" class="d-block mb-2" alt="...">
                  <div class="text-center">
                    <h5>再评正确理解和规范使用间质性肺疾病相关名词概念</h5>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="carousel-item">            
              <div class="d-flex study-list">
                <div class="widthB33">
                  <img src="./assets/new/jzxfbypt_home_yjqyjz_tupian.png" width="150" class="d-block mb-2" alt="...">
                  <div class="text-center">
                    <h5>标题xxx</h5>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
          <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
      </div>
    </div>
  </div>

  <!-- h5端-研究前沿进展 -->
  <div class="module-1 module-5 h5show">
    <div class="title">
      <img class="widthB60" src="./assets/new/jzxfbypt_home_yjqyjz.png" alt="">
    </div>
    <div class="carousel slide">
        <div class="carousel-inner">
          <div class="carousel-item active">
            <div class="study-list">
              <div class="widthB33 cursor-pointer" (click)="goDetails('yjqyjzxq1','研究前沿进展')">
                <img src="./assets/new/jzxfbypt_home_yjqyjz_kesou.png" width="150" class="d-block mb-2" alt="...">
                <div>
                  <h5>咳嗽在间质性肺疾病中的临床意义与管理进展</h5>
                </div>
              </div>
              <div class="widthB33 cursor-pointer" (click)="goDetails('yjqyjzxq2','研究前沿进展')">
                <img src="./assets/new/jzxfbypt_home_yjqyjz_jzxfjbyjjz.png" width="150" class="d-block mb-2" alt="...">
                <div>
                  <h5>间质性肺疾病研究进展</h5>
                </div>
              </div> 
              <div class="widthB33 cursor-pointer" (click)="goDetails('yjqyjzxq3','研究前沿进展')">
                <img src="./assets/new/jzxfbypt_home_yjqyjz_xtxzsmyjczl.png" width="150" class="d-block mb-2" alt="...">
                <div>
                  <h5>系统性自身免疫性风湿病患者间质性肺疾病的筛查与监测和治疗</h5>
                </div>
              </div> 
              <div class="widthB33 cursor-pointer" (click)="goDetails('yjqyjzxq4','研究前沿进展')">
                <img src="./assets/new/jzxfbypt_home_yjqyjz_zpzqljhgf.png" width="150" class="d-block mb-2" alt="...">
                <div class="text-center">
                  <h5>再评正确理解和规范使用间质性肺疾病相关名词概念</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>

  <div class="module-1 module-6">
    <div class="title">
      <img src="./assets/new/jzxfbypt_home_lcsyjyjjd.png" alt="">
    </div>
    <div id="carouselExampleIndicators6" class="carousel slide">
        <div class="carousel-indicators">
          <!-- <button type="button" data-bs-target="#carouselExampleIndicators6" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button> -->
          <!-- <button type="button" data-bs-target="#carouselExampleIndicators6" data-bs-slide-to="1" aria-label="Slide 2"></button> -->
          <!-- <button type="button" data-bs-target="#carouselExampleIndicators6" data-bs-slide-to="2" aria-label="Slide 3"></button> -->
        </div>
        <div class="carousel-inner">
          <div class="carousel-item active">
            <div class="study-list">
              <div class="widthB33 cursor-pointer" (click)="goDetails('lcsyjyjjdxq1','临床试验及研究进度')">
                <img src="./assets/new/jzxfbypt_home_lcsyjyjjd_ppf.png" width="150" class="d-block mb-2" alt="...">
                <div>
                  <h5>进展性肺纤维化（PPF）中国前瞻性多中心登记研究</h5>
                </div>
              </div> 
              <div class="widthB33 cursor-pointer">
                <img src="./assets/new/jzxfbypt_home_yjqyjz_tupian.png" width="150" class="d-block mb-2" alt="...">
                <div>
                  <h5></h5>
                </div>
              </div> 
              <div class="widthB33 cursor-pointer">
                <img src="./assets/new/jzxfbypt_home_yjqyjz_tupian.png" width="150" class="d-block mb-2" alt="...">
                <div>
                  <h5></h5>
                </div>
              </div> 
            </div>
          </div>
          <!-- <div class="carousel-item">  
            <div class="d-flex study-list">
              <div class="widthB33">
                <img src="./assets/new/jzxfbypt_home_yjqyjz_tupian.png" width="150" class="d-block mb-2" alt="...">
                <div class="text-center">
                  <h5>标题xxx</h5>
                </div>
              </div>
            </div>
          </div>
          <div class="carousel-item">            
            <div class="d-flex study-list">
              <div class="widthB33">
                <img src="./assets/new/jzxfbypt_home_yjqyjz_tupian.png" width="150" class="d-block mb-2" alt="...">
                <div class="text-center">
                  <h5>标题xxx</h5>
                </div>
              </div>
            </div>
          </div> -->
        </div>
        <!-- <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators6" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators6" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button> -->
    </div>
  </div>

  <div class="module-1 module-7">
    <div class="title">
      <img src="./assets/new/jzxfbypt_home_zyxz.png" alt="">
    </div>
    
    <div class="introduce-list zyxzs">
      <div>
        <div class="cursor-pointer" (click)="goDetails('zyxz','研究报告')">
          <div><img src="./assets/new/jzxfbypt_home_zyxz_yjbg.png" alt=""></div>
          <div class="titles">研究报告</div>
        </div>
        <div class="cursor-pointer" (click)="goDetails('bgygj','表格与工具')">
          <div><img src="./assets/new/jzxfbypt_home_zyxz_bggj.png" alt=""></div>
          <div class="titles">表格与工具</div>
        </div>
        <div class="cursor-pointer" (click)="goDetails('wxsjk','文献数据库')">
          <div><img src="./assets/new/jzxfbypt_home_zyxz_wxsjk.png" alt=""></div>
          <div class="titles">文献数据库</div>
        </div>
      </div>
    </div>

  </div>
</div>

<!-- 平台简介 -->
<div *ngIf="pages == 'home/ptjj'" class="ptjj">
  <div class="d-banner">
    <img src="./assets/new/jzxfbypt_ptjj_banner.png" alt="">
    <div>
      当前位置：<a (click)="goDetails('home','首页')">首页</a> > <span>平台简介</span>
    </div>
  </div>  
  <div class="con">
    <div class="logo">
      <img src="./assets/new/jzxfbypt_ptjj_bt.png" alt="">
      <div> —— 连接 · 共享 · 赋能，致力于打造国内领先的间质性肺病诊疗与科研生态</div>
    </div>
    <!-- <div class="title"><img src="./assets/new/jzxfbypt_ptjj_jbbj.png" alt=""></div> -->
    <div class="jbbj">
      <img src="./assets/new/jzxfbypt_ptjj_ild_cloud.png" alt="">
      <div><span>间质性肺病（Interstitial Lung Disease, ILD）</span>是一组以肺间质炎症和纤维化为主要特征的慢性异质性疾病，包括特发性肺纤维化（IPF）、结节病、过敏性肺炎等多个亚型。流行病学资料显示，ILD的发病率和患病率正逐年上升，治疗手段有限，对患者生活质量和预后造成严重负担。然而，国内在ILD领域的关注度和规范化诊治水平仍不及其他常见呼吸系统疾病，目前缺乏完善的循证医学证据和统一的病例管理体系，尤其缺少针对中国ILD人群的大规模流行病学与真实世界数据。因此，亟需建立一个覆盖全国的ILD临床与科研平台，以推动标准化诊治、多中心协作研究以及临床诊断试剂和新药研发。</div>
      <div class="widthB100">
        依托中国研究型医院学会呼吸病专委会和北京协和医院徐作军教授团队，联合全国多家三级医院与研究机构，建立能够覆盖全国的专病中心协作网络的间质性肺病云平台（ILD Cloud Platform） ，致力于打造一个集 临床诊治、科研创新、病例管理与多中心合作于一体的综合性平台。
      </div>
    </div>
    <div class="xhyitp"><img src="./assets/new/xhyitp.png" alt=""></div>

  </div>
  <!-- <div class="img-list">
    <div class="img-1">
      <img src="./assets/new/jzxfbypt_ptjj_ic_hzwl.png" alt="">
      <p>平台建设目标</p>
      <span>直面ILD诊治中的，难点与科研瓶颈</span>
    </div>
    <div class="img-2">
      <img src="./assets/new/jzxfbypt_ptjj_ic_hzgh.png" alt="">
      <p>研究重点方向</p>
      <span>积极探索人工智能，与大数据技术</span>
    </div>
    <div class="img-1">
      <img src="./assets/new/jzxfbypt_ptjj_ic_xsqy.png" alt="">
      <p>合作机制与经费来源</p>
      <span>欢迎社会资金支持，共同推动中国ILD研究发展</span>
    </div>
    <div class="img-2">
      <img src="./assets/new/jzxfbypt_ptjj_ic_lcsyydlyj.png" alt="">
      <p>数据管理与学术承诺</p>
      <span>平台采用数字化与智能化管理模式，依托移动互联网和云计算</span>
    </div>
  </div> -->
  
  <div class="hzwl">
    <div class="hzwl-title">
      <img src="./assets/new/jzxfbypt_ptjj_ic_gjhzwl.png" alt="">
      <span>平台建设目标</span>
    </div>
    <div class="hzwl-con">
      间质性肺病云平台旨在全面掌握中国不同地区和人群的流行病学特征与临床现状，直面ILD诊治中的难点与科研瓶颈，推动精准化诊疗。平台将建设全国病例登记与前瞻性队列数据库，形成高质量的真实世界证据；同时探索分子标志物、遗传学与免疫学机制，推动基础成果向临床转化。通过优化诊断流程和评估工具，提升早期诊断与疗效评价能力；依托多中心合作，支撑新药研发和临床试验，加速创新疗法的应用。平台还将积极开展学术交流，培养青年研究者，推动ILD诊治与科研的规范化与系统化发展。秉持 “连接 · 共享 · 赋能” 的理念，致力于提升我国ILD的临床与科研水平，实现患者获益与学科进步。
    </div>
  </div>
  <div class="hzwl">
    <div class="hzwl-title color1c3e86">
      <img src="./assets/new/jzxfbypt_ptjj_ic_hzgh_xiaotu.png" alt="">
      <span>研究重点方向</span>
    </div>
    <div class="hzwl-con">
      研究涵盖从基础到临床的多个层面：一是大规模流行病学研究，明确ILD的发病率、病死率及疾病谱特征；二是分子标志物、遗传学与免疫学机制探索，揭示疾病发生发展的关键过程；三是推动新型诊断流程与评估工具的开发与验证，提高诊断敏感性与准确性。在转化研究方面，平台支持新药研发与临床试验，系统评估新疗法的疗效与安全性；依托病例登记与前瞻性队列建设，积累真实世界数据，推动循证医学证据生成。同时，积极探索 人工智能与大数据技术 在ILD诊断与管理中的应用，如基于AI的影像识别和疾病分型，提升定量分析、早期诊断、疗效监测和预后评估能力。
    </div>
  </div>
  <div class="hzwl">
    <div class="hzwl-title">
      <img src="./assets/new/jzxfbypt_ptjj_ic_xsqy_xiaotu.png" alt="">
      <span>合作机制与经费来源</span>
    </div>
    <div class="hzwl-con">
      平台秉持 开放、平等、合作 的原则，鼓励跨学科、跨区域协作。研究者共同参与方案制定与监督，成果署名严格按贡献排序，确保公开透明。经费来源包括国家级和地方科研基金、企业合作与赞助，同时欢迎社会资金支持，共同推动中国ILD研究发展。
    </div>
  </div>
  <div class="hzwl">
    <div class="hzwl-title color1c3e86">
      <img src="./assets/new/jzxfbypt_ptjj_ic_lcsyydlyj_xiaotu.png" alt="">
      <span>数据管理与学术承诺</span>
    </div>
    <div class="hzwl-con">
      <p>
        平台采用 数字化与智能化 管理模式，依托移动互联网和云计算，实现病例与队列的动态质控。通过标准化录入与审核流程，保障数据完整可靠；严格权限分级，保护患者隐私，符合国内外医学伦理与数据安全规范。研究者承诺严格遵守《赫尔辛基宣言》，确保数据真实可靠，坚决抵制学术不端，坚持以患者利益为核心，推动成果向临床实践转化。
      </p>
      <p>
        综上，间质性肺病云平台将联结全国临床与科研资源，构建开放、共享、规范的研究与诊治生态，推动中国ILD研究走向国际前沿，发出“中国声音”。
      </p>
    </div>
  </div>
  <div class="bottom-img"><img src="./assets/new/jzxfbypt_ptjj_ptyj.png" alt=""></div>
</div>

<!-- 通知通告 -->
<div *ngIf="pages == 'home/tztg'">
  <div class="d-banner tzgg-banner">
    <img src="./assets/new/jjzxfbypt_tztg_banner.png" alt="">    
    <div>
      当前位置：<a (click)="goDetails('home','首页')">首页</a> > <span>通知通告</span>
    </div>
  </div>
  <div class="tzgg-con" style="display: none;">
    <ul class="tzgg-list">
      <li>
        <img src="./assets/new/jzxfbypt_tztg_ic_tubiao.png" alt="">
        <span>XXXXXXXXXXXXXXXXXX,XXXXXXXXXXXXXXXXXXXX,XXXXXXXXXXXXX,XXXXXXXXXXXXXXXXXXXXXXX,XXXXXXXXXXXXXXXXX</span>
        <p>2025-07-17</p>
      </li>
      <li>
        <img src="./assets/new/jzxfbypt_tztg_ic_tubiao.png" alt="">
        <span>XXXXXXXXXXXXXXXXXX,XXXXXXXXXXXXXXXXXXXX,XXXXXXXXXXXXX,XXXXXXXXXXXXXXXXXXXXXXX,XXXXXXXXXXXXXXXXX</span>
        <p>2025-07-17</p>
      </li>
      <li>
        <img src="./assets/new/jzxfbypt_tztg_ic_tubiao.png" alt="">
        <span>XXXXXXXXXXXXXXXXXX,XXXXXXXXXXXXXXXXXXXX,XXXXXXXXXXXXX,XXXXXXXXXXXXXXXXXXXXXXX,XXXXXXXXXXXXXXXXX</span>
        <p>2025-07-17</p>
      </li>
      <li>
        <img src="./assets/new/jzxfbypt_tztg_ic_tubiao.png" alt="">
        <span>XXXXXXXXXXXXXXXXXX,XXXXXXXXXXXXXXXXXXXX,XXXXXXXXXXXXX,XXXXXXXXXXXXXXXXXXXXXXX,XXXXXXXXXXXXXXXXX</span>
        <p>2025-07-17</p>
      </li>
      <li>
        <img src="./assets/new/jzxfbypt_tztg_ic_tubiao.png" alt="">
        <span>XXXXXXXXXXXXXXXXXX,XXXXXXXXXXXXXXXXXXXX,XXXXXXXXXXXXX,XXXXXXXXXXXXXXXXXXXXXXX,XXXXXXXXXXXXXXXXX</span>
        <p>2025-07-17</p>
      </li>
    </ul>
  </div>  
  <div class="no-content">暂无内容</div>
</div>

<!-- 中心及专家介绍 -->
<div *ngIf="pages == 'home/zxjzjjs'" class="bg-fff">
  <div class="d-banner zxjzjjs-banner">
    <img src="./assets/new/jzxfbypt_zxjzjjs_tittle_zx.png" alt="">    
    <div>
      当前位置：<a (click)="goDetails('home','首页')">首页</a> > <span>中心及专家介绍</span>
    </div>
  </div>
  <div class="zxjzjjs-list min-height500">
    <div (click)="goDetails('zxjzjjsbjxhyy','北京协和医院')">
      <img src="./assets/new/bjxhyy.png" alt="" class="cursor-pointer">
      <div>北京协和医院</div>      
    </div>
    <div>
      <img src="./assets/new/bjazyy.png" alt="" class="cursor-pointer">
      <div>北京朝阳医院</div>      
    </div>
  </div>
</div>

<!-- 中心及专家介绍-北京协和医院 -->
<div *ngIf="pages == 'home/zxjzjjsbjxhyy'" class="bg-fff">
  <div class="d-banner zxjzjjs-banner">
    <img src="./assets/new/jzxfbypt_zxjzjjs_tittle_zx.png" alt="">
    <div>
      当前位置：<a (click)="goDetails('home','首页')">首页</a> > <a (click)="goDetails('zxjzjjs','首页')">中心及专家介绍</a> > <span>北京协和医院</span>
    </div>
  </div>
  <div class="zjjs-title">
      <img src="./assets/new/jzxfbypt_zxjzjjs_zx_zxjs.png" alt="">
      <img src="./assets/new/jzxfbypt_zxjzjjs_zx_xhyy.png" alt="">
  </div>
  <div class="zxjszw">
    <div>
      <p class="title">北京协和医院呼吸与危重症医学科间质性肺病专病中心介绍</p>
      <p>北京协和医院在间质性肺病（Interstitial Lung Disease, ILD）的诊治与研究方面拥有悠久的历史和深厚的积淀。早在上世纪八九十年代，罗慰慈教授、朱元珏教授便率先在国内开展系统研究，为我国ILD学科的建立奠定了坚实基础。经过数十年的发展，北京协和医院呼吸与危重症医学科间质性肺病专病中心已成为国内最具影响力的诊疗与研究基地之一。</p>

      <p>目前，专病中心由徐作军教授领衔。徐教授是我国ILD领域的学术带头人，担任多个全国性学术组织的重要职务，长期致力于弥漫性间质性肺疾病、结节病及急性肺损伤等研究。在国际权威期刊发表了大量成果，主持国家重点课题，牵头多项新药临床研究，为推动我国ILD的规范化诊疗和学科发展作出了重要贡献。</p>

      <p>在徐作军教授带领下，中心形成了完善的人才梯队。团队汇聚了黄慧教授、王平副教授、邵池副教授等多位专家，在临床诊治和科研方面均有突出建树，并培养了一批中青年骨干力量，为学科持续发展注入了活力。</p>

      <p>临床方面，中心率先建立ILD专病门诊和多学科会诊（MDT）模式，联合影像学、病理学、风湿免疫、胸外科等多学科力量，为复杂疑难病例提供个体化诊疗方案。中心在吡非尼酮、尼达尼布等抗纤维化药物的应用方面积累了最丰富的临床经验，并主持和参与了国内外最多的多中心临床研究，形成了全国规模最大的真实世界病例数据库。</p>

      <p>学术方面，中心牵头制定和修订了多项国内ILD相关诊疗指南与专家共识，涵盖特发性肺纤维化、过敏性肺炎、药物性肺损伤等多个亚型，成为全国临床医生的重要实践参考。依托“间质性肺病云平台”，中心推动了全国范围内的队列登记和临床研究，为制定符合中国人群特点的诊疗策略提供了重要依据。</p>

      <p>作为国内最早起步、研究最系统、影响力最大的ILD诊疗中心之一，北京协和医院呼吸与危重症医学科间质性肺病专病中心将继续秉持协和精神，致力于推动学科规范化、精准化和国际化发展，为广大患者带来更科学、更有效的诊疗与关怀。</p>
    </div>
  </div>
  <div class="zjjs-title">
    <img src="./assets/new/jzxfbypt_zxjzjjs_zx_zjjs.png" alt="">
  </div>
  <div class="zxjzjjs-list zxjzjjs-list2">
    <div (click)="goDetails('zjxx1','专家信息')" class="cursor-pointer">
      <img src="./assets/new/jzxfbypt_home_doctor_xzj.png" alt="">
      <div>徐作军</div>  
      <div class="color999">北京协和医院</div>    
    </div>
    <div (click)="goDetails('zjxx2','专家信息')" class="cursor-pointer">
      <img src="./assets/new/jzxfbypt_home_doctor_hh.png" alt="">
      <div>黄慧</div>  
      <div class="color999">北京协和医院</div>      
    </div>
    <div (click)="goDetails('zjxx3','专家信息')" class="cursor-pointer">
      <img src="./assets/new/jzxfbypt_home_doctor_wp.png" alt="">
      <div>王平</div> 
      <div class="color999">北京协和医院</div>       
    </div>
    <div (click)="goDetails('zjxx4','专家信息')" class="cursor-pointer">
      <img src="./assets/new/jzxfbypt_home_doctor_sc.png" alt="">
      <div>邵池</div>   
      <div class="color999">北京协和医院</div>     
    </div>
  </div>
</div>

<!-- 专家信息-徐作军 -->
<div *ngIf="pages == 'home/zjxx1'">
  <div class="d-banner banner-xzj">
    <img src="./assets/new/jzxfbypt_zxjzjjs_tittle_ys.png" alt="">    
    <div>
      当前位置：<a (click)="goDetails('home','首页')">首页</a> > <a (click)="goDetails('zxjzjjs','首页')">中心及专家介绍</a> > <a (click)="goDetails('zxjzjjsbjxhyy','首页')">北京协和医院</a>
    </div>
  </div>

  <div class="expert">
    <div class="container">
      <div class="left">
        <img width="200" src="./assets/new/jzxfbypt_zxjzjjs_xzj.png" alt="">
        <div class="name">徐作军</div>
        <div class="hospital">北京协和医院</div>
      </div>
      <div class="right">
        <div>          
          <img width="30" src="./assets/new/jzxfbypt_zxjzjjs_ic_ysjj.png" alt="">
          <div class="hospital-title">
            医生简介：
          </div>
          <div class="mt-2 widthB100">
            <p>医学博士，北京协和医院呼吸与危重症医学科主任医师，教授，博士生导师。</p>
          </div>
        </div>
        <div>          
          <img width="30" src="./assets/new/jzxfbypt_zxjzjjs_ic_xsrz.png" alt="">
          <div class="hospital-title">
            学术任职：
          </div>
          <div class="mt-2 widthB100">
            <p><span class="color4256ec">&bull;</span>担任中国研究型医院学会呼吸病专业委员会主任委员</p>
            <p>
              <span class="color4256ec">&bull;</span>中国老年医学学会呼吸病学分会副会长
            </p>
            <p>
              <span class="color4256ec">&bull;</span>中国间质性疾病多学科诊治专家委员会主任委员、中华医学会呼吸病分会第7-10届间质病学组副组长等
            </p>            
          </div>
        </div>
        <div>          
          <img width="30" src="./assets/new/jzxfbypt_zxjzjjs_ic_yjfxjcg.png" alt="">
          <div class="hospital-title">
            研究方向及成果：
          </div>
          <div class="mt-2 widthB100">
            <p><span class="color4256ec">&bull;</span>重点研究方向是弥漫性间质性肺疾病、结节病、肺部感染和急性肺损伤等</p>
            <p><span class="color4256ec">&bull;</span>主持和承担多项国家级研究课题和计划</p>
            <p><span class="color4256ec">&bull;</span>曾获北京市科学技术进步一等奖1项，中华医学科技二等奖1项</p>
            <p><span class="color4256ec">&bull;</span>在nature medicine等杂志发表研究成果百余篇</p>
            <p><span class="color4256ec">&bull;</span>参加了35本专著的编写</p>
            <p><span class="color4256ec">&bull;</span>牵头主持多项国内和国际肺纤维化新药临床研究</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- 专家信息-黄慧 -->
<div *ngIf="pages == 'home/zjxx2'">
  <div class="d-banner banner-xzj">
    <img src="./assets/new/jzxfbypt_zxjzjjs_tittle_ys.png" alt="">
    <div>
      当前位置：<a (click)="goDetails('home','首页')">首页</a> > <a (click)="goDetails('zxjzjjs','首页')">中心及专家介绍</a> > <a (click)="goDetails('zxjzjjsbjxhyy','首页')">北京协和医院</a>
    </div>
  </div>

  <div class="expert">
    <div class="container">
      <div class="left">
        <img width="200" src="./assets/new/jzxfbypt_zxjzjjs_hh.png" alt="">
        <div class="name">黄慧</div>
        <div class="hospital">北京协和医院</div>
      </div>
      <div class="right">
        <div>          
          <img width="30" src="./assets/new/jzxfbypt_zxjzjjs_ic_ysjj.png" alt="">
          <div class="hospital-title">
            医生简介：
          </div>
          <div class="mt-2 widthB100">
            <p>医学博士，北京协和医院呼吸与危重症医学科副主任，主任医师、教授，博士研究生及博士后导师。</p>
          </div>
        </div>
        <div>          
          <img width="30" src="./assets/new/jzxfbypt_zxjzjjs_ic_xsrz.png" alt="">
          <div class="hospital-title">
            学术任职：
          </div>
          <div class="mt-2 widthB100">
            <p><span class="color4256ec">&bull;</span>现任中华医学会呼吸病学分会间质性肺疾病的学组委员</p>
            <p>
              <span class="color4256ec">&bull;</span>中国医师协会呼吸病学分会间质性肺疾病工作委员会委员
            </p>
            <p>
              <span class="color4256ec">&bull;</span>中国研究型医院学会呼吸病学专委会常委
            </p>  
            <p><span class="color4256ec">&bull;</span>北京医学会呼吸病学分会委员以及间质性肺疾病学组委员</p>      
            <p><span class="color4256ec">&bull;</span>《中华结核和呼吸杂志》、《中华医学杂志》中文版通讯编委</p>    
          </div>
        </div>
        <div>          
          <img width="30" src="./assets/new/jzxfbypt_zxjzjjs_ic_yjfxjcg.png" alt="">
          <div class="hospital-title">
            研究方向及成果：
          </div>
          <div class="mt-2 widthB100">
            <p><span class="color4256ec">&bull;</span>主要从事间质性肺疾病、肺部特殊感染的临床和基础研究</p>
            <p><span class="color4256ec">&bull;</span>主持及参与多项院校级基金、北京市自然科学基金、<br>国家自然科学基金、科技部重点专项</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- 专家信息-王平 -->
<div *ngIf="pages == 'home/zjxx3'">
  <div class="d-banner banner-xzj">
    <img src="./assets/new/jzxfbypt_zxjzjjs_tittle_ys.png" alt="">
    <div>
      当前位置：<a (click)="goDetails('home','首页')">首页</a> > <a (click)="goDetails('zxjzjjs','首页')">中心及专家介绍</a> > <a (click)="goDetails('zxjzjjsbjxhyy','首页')">北京协和医院</a>
    </div>
  </div>

  <div class="expert">
    <div class="container">
      <div class="left">
        <img width="200" src="./assets/new/jzxfbypt_zxjzjjs_wp.png" alt="">
        <div class="name">王平</div>
        <div class="hospital">北京协和医院</div>
      </div>
      <div class="right">
        <div>          
          <img width="30" src="./assets/new/jzxfbypt_zxjzjjs_ic_ysjj.png" alt="">
          <div class="hospital-title">
            医生简介：
          </div>
          <div class="mt-2 widthB100">
            <p>医学博士，北京协和医院呼吸与危重症医学科副主任医师</p>
          </div>
        </div>
        <div>          
          <img width="30" src="./assets/new/jzxfbypt_zxjzjjs_ic_xsrz.png" alt="">
          <div class="hospital-title">
            学术任职：
          </div>
          <div class="mt-2 widthB100">
            <p><span class="color4256ec">&bull;</span>担任中国研究型医院学会呼吸病学专业委员会常务委员兼秘书长</p>
            <p>
              <span class="color4256ec">&bull;</span>北京医学会呼吸分会间质病学组委员
            </p>          
          </div>
        </div>
        <div>          
          <img width="30" src="./assets/new/jzxfbypt_zxjzjjs_ic_yjfxjcg.png" alt="">
          <div class="hospital-title">
            研究方向及成果：
          </div>
          <div class="mt-2 widthB100">
            <p><span class="color4256ec">&bull;</span>长期从事间质性肺炎、肺间质纤维化、肺部疑难罕见病、肺部特殊感染的诊疗及临床研究</p>
            <p><span class="color4256ec">&bull;</span>主持北京自然科学基金项目一项，参加国家自然科学基金和国家重点研发计划多项，参加多项肺纤维化新药临床研究</p>
            <p><span class="color4256ec">&bull;</span>在国内外核心期刊发表间质性肺疾病相关和呼吸系统疑难罕见病相关论文篇</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- 专家信息-邵池 -->
<div *ngIf="pages == 'home/zjxx4'">
  <div class="d-banner banner-xzj">
    <img src="./assets/new/jzxfbypt_zxjzjjs_tittle_ys.png" alt="">
    <div>
      当前位置：<a (click)="goDetails('home','首页')">首页</a> > <a (click)="goDetails('zxjzjjs','首页')">中心及专家介绍</a> > <a (click)="goDetails('zxjzjjsbjxhyy','首页')">北京协和医院</a>
    </div>
  </div>

  <div class="expert">
    <div class="container">
      <div class="left">
        <img width="200" src="./assets/new/jzxfbypt_zxjzjjs_sc.png" alt="">
        <div class="name">邵池</div>
        <div class="hospital">北京协和医院</div>
      </div>
      <div class="right">
        <div>          
          <img width="30" src="./assets/new/jzxfbypt_zxjzjjs_ic_ysjj.png" alt="">
          <div class="hospital-title">
            医生简介：
          </div>
          <div class="mt-2 widthB100">
            <p>医学博士，北京协和医院呼吸与危重症医学科副主任医师。</p>
          </div>
        </div>
        <div>          
          <img width="30" src="./assets/new/jzxfbypt_zxjzjjs_ic_xsrz.png" alt="">
          <div class="hospital-title">
            学术任职：
          </div>
          <div class="mt-2 widthB100">
            <p><span class="color4256ec">&bull;</span>担任中华老年病学会呼吸分会间质病学术委员会秘书</p>
            <p>
              <span class="color4256ec">&bull;</span>中国研究型医院学会呼吸内科专业委员会秘书
            </p>          
          </div>
        </div>
        <div>          
          <img width="30" src="./assets/new/jzxfbypt_zxjzjjs_ic_yjfxjcg.png" alt="">
          <div class="hospital-title">
            研究方向及成果：
          </div>
          <div class="mt-2 widthB100">
            <p><span class="color4256ec">&bull;</span>主要专业方向为肺间质疾病和支气管镜介入技术</p>
            <p><span class="color4256ec">&bull;</span>参与多项国家自然科学基金。发表SCI论文十余篇</p>
            <p><span class="color4256ec">&bull;</span>参与编写《协和呼吸病学》，《协和医院疑难间质性肺疾病典型病例分析》等著作</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- 患者科普列表 -->
<div *ngIf="pages == 'home/hzkp'" class="bg-fff">
  <div class="d-banner hzkp-banner">
    <img src="./assets/new/jzxfbypt_hzkp_tittle.png" alt="">
    <div>
      当前位置：<a (click)="goDetails('home','首页')">首页</a> > <span>患者科普</span>
    </div>
  </div>
  <div class="module-1 module-4 min-height500">
    <div class="video">
      <div class="cursor-pointer" (click)="goDetails('hzkpxq1','患者科普')">
        <div><img src="./assets/new/jzxfbypt_home_hzkp_kesou.png" alt=""></div>
        <div>当咳嗽不再只是症状：<br>间质性肺疾病患者如何从声音中读懂病情变化</div>
      </div>
      <div class="cursor-pointer" (click)="goDetails('hzkpxq2','患者科普')">
        <div><img src="./assets/new/jzxfbypt_home_hzkp_tips.png" alt=""></div>
        <div>间质性肺病患者就诊小贴示</div>
      </div>
    </div>
  </div>
</div>

<!-- 患者科普 - 详情 -->
<div *ngIf="pages == 'home/hzkpxq1'" class="bg-fff">
  <div class="d-banner hzkp-banner">
    <img src="./assets/new/jzxfbypt_hzkp_tittle.png" alt="">
    <div>
      当前位置：<a (click)="goDetails('home','首页')">首页</a> > <a (click)="goDetails('hzkp','首页')">患者科普</a>
    </div>
  </div>
  
  <div class="hzkp-con">
    <div class="size-1">
      当咳嗽不再只是症状
    </div>
    <div class="size-2">
      间质性肺疾病患者如何从声音中读懂病情变化
    </div>
    <img src="./assets/new/jzxfbypt_hzkp_dksbzzszz.png" alt="">
    <div class="size-3">
      一、ILD 咳嗽的临床特点与机制
    </div>
    <div>
      在间质性肺疾病（Interstitial Lung Disease, ILD）中，咳嗽是最常见且困扰患者的症状之一。与哮喘、COPD 等阻塞性疾病不同，ILD 咳嗽通常表现为：
    </div>
    <div>
      <p><span>•</span>	干咳为主，很少或没有痰；</p>
      <p><span>•</span>	持续时间长，活动后或夜间更明显；</p>
      <p><span>•</span>	常与气短/呼吸困难一起出现；</p>
      <p><span>•</span>	对常见止咳药效果不理想。</p>
      <p>为什么会这样？可能与以下因素有关：</p>
      <p><span>•</span>	肺纤维化使小气道受到牵拉与压迫，容易触发咳嗽；</p>
      <p><span>•</span>	慢性炎症与上皮损伤使气道更加敏感；</p>
      <p><span>•</span>	神经敏感性增强（迷走神经易兴奋）；</p>
      <p><span>•</span>	并存因素如胃食管反流（GERD）、部分药物（如 ACEI）也会加重咳嗽。</p>
      <p>咳嗽既影响生活质量，也可能是病情活动或加重的早期信号，需要被重视和记录。</p>
    </div>
    <div class="size-3">
      二、传统评估方式的不足
    </div>
    <div>
      门诊常用的量表（如 VAS、LCQ、CQLQ），以及影像学（HRCT：高分辨率肺部 CT）和肺功能（如 FVC/FEV₁：评估肺容量与气流）能帮助医生判断病情，但这些方法多为间断检测、依赖主观感受，难以反映长期、连续的变化趋势。
    </div>
    <div class="size-3">
      三、我们能做什么：把“咳嗽声”变成可追踪的数据
    </div>
    <div>
      1. 门诊/住院监测版
    </div>
    <div>
      <p><span>•</span>	采集声音：在随访时录制咳嗽声和用力呼气声；</p>
      <p><span>•</span>	智能分析：算法自动量化咳嗽的频次、强度、时长及呼气的声学特征，并与肺功能（如 FVC、FEV₁）建立关联；</p>
      <p><span>•</span>	建立基线：形成每位患者独有的“声音指纹”，随时间比较变化；</p>
      <p><span>•</span>	多模态融合：把声音数据与症状、肺功能、影像结合，辅助识别 ILD 向进展性肺纤维化（PPF）转变的风险。</p>
    </div>
    <div>
      2. 居家监测版
    </div>
    <div>
      <p><span>•</span>	被动记录：使用手机，日常自动捕捉夜间咳嗽事件，患者几乎无操作负担；</p>
	    <p><span>•</span>	趋势追踪：分析频率、持续时间、整晚咳嗽次数，生成长期曲线；</p>
	    <p><span>•</span>	临床意义：当曲线提示异常上升时，更早提醒复诊，作为 PPF“症状/功能/影像”三维框架的有力补充证据。</p>
    </div>
    <div>
      <p class="cursor-pointer" data-bs-toggle="modal" data-bs-target="#staticBackdrop2"><span>查看视频 >></span></p>
    </div>
    
    <div class="modal fade" id="staticBackdrop2" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="staticBackdropLabel">视频</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>        
              <video src="https://cdn.lucahealthcare.cn/common/video/pumch/patient.mp4" controls="controls"></video>
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">关闭</button>
            <button type="button" class="btn btn-primary">确定</button>
          </div>
        </div>
      </div>
    </div>


    <div class="size-3">
      四、对患者的实际价值
    </div>
    <div>
      <p><span>•</span>	更安全、更省力：减少不必要的检查与往返就医，提升用药安全性，降低时间与经济成本；</p>
	    <p><span>•</span>	更客观：提供连续、可复现的量化指标，作为 HRCT 和传统肺功能的重要补充，让医生更全面地了解病情。</p>
      <p>提醒：声音监测是辅助工具，不能替代 HRCT 与标准肺功能检查。最终诊断与治疗仍需由医生结合所有信息综合评估。</p>
    </div>
    <div class="size-3">
      五、给患者的小建议
    </div>
    <div>
      <p><span>•</span>	坚持记录：若使用居家监测，请按说明持续使用，别轻易中断；</p>
      <p><span>•</span>	标注事件：明显加重的那几天，尽量记录作息、活动、感染或胃酸反流情况，方便医生判断诱因；</p>
      <p><span>•</span>	及时沟通：监测曲线出现持续上升或呼吸困难加重，尽快与医生联系；</p>
      <p><span>•</span>	综合管理：配合医生完成规律复诊、肺功能/影像检查，留意反流、药物影响等可干预因素，并坚持呼吸康复训练。</p>
    </div>
    <div class="size-3">
      六、总结
    </div>
    <div>
      <p>咳嗽声正在从“症状”升级为可被量化与追踪的“新指标”。</p>
      <p>借助声音监测，医生与患者能更早识别风险、更快做出调整、更清晰看到趋势。当它与影像、肺功能等标准评估协同工作时，能为 ILD 患者带来更确定、更高效的管理路径。</p>
      <p>&nbsp;</p>
    </div>
    
  </div>

  <!-- <div class="module-1 module-4 py-5">
    <img src="./assets/new/jzxfbypt_home_zxjzjjs_xhyy.png" alt="">
    <div class="video">
      <div>
        <div><img src="./assets/new/jzxfbypt_home_kpsp.png" alt=""></div>
        <div>科普一</div>
      </div>
      <div>
        <div><img src="./assets/new/jzxfbypt_home_kpsp.png" alt=""></div>
        <div>科普二</div>
      </div>
      <div>
        <div><img src="./assets/new/jzxfbypt_home_kpsp.png" alt=""></div>
        <div>科普三</div>
      </div>
      <div>
        <div><img src="./assets/new/jzxfbypt_home_kpsp.png" alt=""></div>
        <div>科普四</div>
      </div>
    </div>
  </div> -->

</div>

<!-- 患者科普 - 详情2 -->
<div *ngIf="pages == 'home/hzkpxq2'" class="bg-fff">
  <div class="d-banner hzkp-banner">
    <img src="./assets/new/jzxfbypt_hzkp_tittle.png" alt="">
    <div>
      当前位置：<a (click)="goDetails('home','首页')">首页</a> > <a (click)="goDetails('hzkp','首页')">患者科普</a>
    </div>
  </div>
  
  <div class="hzkp-con2">
    <div class="size-1">
      间质性肺病患者就诊小贴示
    </div>
    <img src="./assets/new/jzxfbypt_hzkp_tips.png" alt="">
    <div class="size-2">
      <img src="./assets/new/jzxfbypt_hzkp_jzxl.png" alt="">
    </div>   
    <div class="size-3">
      间质性肺病是一类需要长期随访和精细管理的疾病。很多患者在门诊时都会有这样的困惑：
    </div>
    <img src="./assets/new/jzxfbypt_hzkp_ts.png" alt="">
    <div class="size-3">
      其实，这并不是医生“临时加项目”，而是因为患者在就诊时没有带齐关键资料，医生无法一次性全面评估，只能分步追加。这样不仅耽误了诊疗效率，还增加了患者的时间和精力负担。
    </div>
    <div class="size-3">
      那么，如何才能最有效率地完成门诊就诊呢？
    </div>
    <div class="size-3 font-bold">
      我们建议患者每次来门诊时，都要带齐以下几类检查资料。
    </div>
    <div class="size-4">
      <img src="./assets/new/jzxfbypt_hzkp_hrct.png" alt="">
    </div>
    <div class="size-3">
      就诊时，患者一定要携带<span>既往多次的高分辨率计算机断层扫描（HRCT，层厚小于2毫米）</span>。这是医生判断病情进展的关键依据。是否需要新拍 HRCT，要由医生根据病情决定，而不是每次就诊都要重复检查。
    </div>
    <div class="size-3">
      为了便于快速找到并对比，建议在胶片上方贴一条小标签，写清楚<span>检查日期和医院</span>（注意不要遮挡影像部分），这样医生可以快速理清检查顺序。
    </div>
    <div class="size-5">
      <img src="./assets/new/jzxfbypt_hzkp_jzxfxjj.png" alt="">
    </div>
    <div class="size-3">
      不同的随访目的，对影像的要求也不同：
    </div>
    <div class="size-3">
      <p><span>• </span><strong> 间质性肺病患者</strong>：医生更倾向于观察肺部整体病变范围的变化，<span>需要多层面、前后多次、层厚一致的 HRCT 胶片</span>，方便在同一层面对比（建议每次在同一家医院，拍同样层厚的CT片子）。</p>
    </div>
    <div class="size-3">
      <p><span>• </span><strong>小结节随访患者</strong>：医生更关注局部结节的大小和形态变化，更适合使用<span>带有明确标注层面和大小测量报告、可放大查看的电子版影像。</span>
    </div>
    <div class="size-3">
      简单来说：间质病看“面”的演变，小结节看“点”的变化。
    </div>
    <div class="size-6">  
      <img src="./assets/new/jzxfbypt_hzkp_fgnjc.png" alt="">
    </div>
    <div class="size-3">
      在复查 HRCT 的同时，建议患者同步进行一次肺功能检查。至少包括以下几个项目：
    </div>
    <div class="size-3">
      <p><span>• </span><strong>用力肺活量（FVC）</strong>：反映肺容量是否下降；</p>
      <p><span>• </span><strong>第一秒用力呼气容积（FEV1）</strong>：帮助评估气道功能；</p>
      <p><span>• </span><strong>一氧化碳弥散量（DLCO）</strong>：敏感反映气体交换受损，是疾病进展的重要指标；</p>
      <p><span>• </span><strong>总肺容量（TLC）</strong>：用于评估肺容量减少的程度。</p>
      <p>医生会将影像学和肺功能结果结合起来，更全面地判断疾病进展和治疗效果。</p>
    </div>
    <div class="size-7">  
      <img src="./assets/new/jzxfbypt_hzkp_xyjc.png" alt="">
    </div>
    <div class="size-3">
      <p>对于初次就诊、需要明确诊断的患者，建议都进行<span>抗核抗体谱</span>检测，这是最基础的自身免疫筛查，可以提示是否存在结缔组织相关疾病。</p>
    </div>
    <div class="size-3">
      <p>至于是否需要进一步检查特殊抗体谱，例如<span>肌炎抗体谱、抗中性粒细胞胞浆抗体、类风湿因子</span>等，要结合患者的临床表现，由接诊医生来决定。这样既能避免漏诊，也能减少不必要的检查和经济负担。</p>
    </div>
    <div class="size-8">  
      <img src="./assets/new/jzxfbypt_hzkp_zj.png" alt="">
    </div>
    <div class="size-3">
      <p>间质性肺病的规范随访需要多方面资料的结合：</p>
    </div>
    <div class="size-3 size-9">
      <p><span>• </span><strong>HRCT</strong> → 提供病变影像依据</p>
      <p><span>• </span><strong>肺功能</strong> → 反映肺的工作效率</p>
      <p><span>• </span><strong>血液学检查</strong> → 排查免疫相关疾病继发病因</p>
      <p>患者在就诊时带齐并整理好这些检查结果，不仅能帮助医生更准确地评估病情，也能避免重复检查，节省时间和费用。</p>
    </div>
    <div class="size-3">
      想了解更多就诊与随访管理的小贴士，欢迎关注我们的公众号 <span>「间肺云」</span> 和患者教育平台 <span>「间肺家园」</span>，获取后续更新与更多实用内容。
    </div>

  </div>
</div>


<!-- 研究前沿进展-列表 -->
<div *ngIf="pages == 'home/yjqyjz'" class="bg-fff">
  <div class="d-banner yjqyjz-banner">
    <img src="./assets/new/jzxfbypt_yjqyjz_tittle.png" alt="">
    <div>
      当前位置：<a (click)="goDetails('home','首页')">首页</a> > <span>研究前沿进展</span>
    </div>
  </div>
    
  <div class="module-1 module-5 min-height500">
    <div class="carousel slide">
        <div class="study-list">
          <div class="widthB33 cursor-pointer" (click)="goDetails('yjqyjzxq1','研究前沿进展')">
            <img src="./assets/new/jzxfbypt_home_yjqyjz_kesou.png" width="150" class="d-block mb-2" alt="...">
            <div>
              <h5>咳嗽在间质性肺疾病中的临床意义与管理进展</h5>
            </div>
          </div>
          <div class="widthB33 cursor-pointer" (click)="goDetails('yjqyjzxq2','研究前沿进展')">
            <img src="./assets/new/jzxfbypt_home_yjqyjz_jzxfjbyjjz.png" width="150" class="d-block mb-2" alt="...">
            <div>
              <h5>间质性肺疾病研究进展</h5>
            </div>
          </div> 
          <div class="widthB33 cursor-pointer" (click)="goDetails('yjqyjzxq3','研究前沿进展')">
            <img src="./assets/new/jzxfbypt_home_yjqyjz_xtxzsmyjczl.png" width="150" class="d-block mb-2" alt="...">
            <div>
              <h5>系统性自身免疫性风湿病患者间质性肺疾病的筛查与监测和治疗</h5>
            </div>
          </div> 
          <div class="widthB33 cursor-pointer" (click)="goDetails('yjqyjzxq4','研究前沿进展')">
            <img src="./assets/new/jzxfbypt_home_yjqyjz_zpzqljhgf.png" width="150" class="d-block mb-2" alt="...">
            <div>
              <h5>再评正确理解和规范使用间质性肺疾病相关名词概念</h5>
            </div>
          </div> 
        </div>
    </div>
  </div>
    
</div>

<!-- 研究前沿进展-详情1 -->
<div *ngIf="pages == 'home/yjqyjzxq1'" class="bg-fff">
  <div class="d-banner yjqyjz-banner">
    <img src="./assets/new/jzxfbypt_yjqyjz_tittle.png" alt="">
    <div>
      当前位置：<a (click)="goDetails('home','首页')">首页</a> > <a (click)="goDetails('yjqyjz','首页')">研究前沿进展</a>
    </div>
  </div>

  <div class="hzkp-con">
    <div class="size-2 text-indent0">
      咳嗽在间质性肺疾病中的临床意义与管理进展
    </div>
    <img src="./assets/new/jzxfbypt_yjqyjz_kszjzxfjbzdlcyy.png" alt="">
    <div class="size-3">
      一、临床特征与疾病负担
    </div>
    <div>
      咳嗽是间质性肺疾病（Interstitial Lung Disease, ILD）最常见的临床表现之一，其发生率在不同亚型中可达 70%–90%。不同于哮喘和慢性阻塞性肺疾病（COPD），ILD 咳嗽多表现为干咳、少痰或无痰，呈慢性持续性，常在活动后或夜间加重，且对常规止咳药反应有限。咳嗽常伴随呼吸困难，不仅显著降低患者生活质量，还与疾病进展、住院率和死亡风险密切相关。因此，咳嗽在ILD 中既是主要症状负担，也是潜在的疾病活动度和预后表型。
    </div>
    <div class="size-3">
      二、病理生理机制
    </div>
    <div>
      <p>ILD 咳嗽的发生涉及多种机制：</p>
      <p><span>肺纤维化与机械牵拉：</span>纤维化导致小气道受压与牵拉，刺激咳嗽感受器；</p>
      <p><span>气道炎症与上皮损伤：</span>慢性炎症引起咳嗽反射敏感性增加；</p>
      <p><span>神经源性机制：</span>迷走神经兴奋性增强，类似于慢性难治性咳嗽的神经病理基础；</p>
      <p><span>并存因素：</span>胃食管反流（GERD）、上气道咳嗽综合征（UACS）、药物（如ACEI）等均可加重咳嗽。</p>
    </div>
    <div class="size-3">
      三、现有评估与治疗策略
    </div>
    <div>
      <p>临床常用的咳嗽评估方法包括 VAS 评分、LCQ、CQLQ 等量表，以及结合 HRCT 和肺功能（DLCO、FVC） 的综合判断。然而，这些方法依赖患者主观感受或间断检测，缺乏连续、客观、长期的趋势监测。</p>
      <p>
        治疗方面，除抗纤维化药物（吡非尼酮、尼达尼布）在部分患者中可改善咳嗽外，常规止咳药（如右美沙芬、喷托维林、可待因）疗效有限；新型神经调控药物（如 P2X3 受体拮抗剂gefapixant）正在临床研究中显示潜力。此外，呼吸康复和呼吸操训练等非药物干预在改善症状感受方面亦有价值。
      </p>      
    </div>
    <div class="size-3">
      四、咳嗽声音监测的应用探索
    </div>
    <div>
      为克服传统评估工具的局限，北京协和医院徐作军教授课题组联合起源波江数字医疗科技（上海）有限公司，开展了 ILD 患者咳嗽音监测研究，尝试将声音信号转化为可量化的疾病监测指标。
    </div>
        
    <div>
      <p class="cursor-pointer" data-bs-toggle="modal" data-bs-target="#staticBackdrop3"><span>查看视频 >></span></p>
    </div>
    
    <div class="modal fade" id="staticBackdrop3" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="staticBackdropLabel">视频</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>        
              <video src="https://cdn.lucahealthcare.cn/common/video/pumch/doctor.mp4" controls="controls"></video>
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">关闭</button>
            <button type="button" class="btn btn-primary">确定</button>
          </div>
        </div>
      </div>
    </div>

    <div>
      <p><span>门诊/住院采集：</span>在随访时录制咳嗽与吹气音，利用算法分析咳嗽频率、音强、时长及呼气等特征，并与肺功能参数（FVC、FEV₁）建立模型，形成个体化“声音指纹”。</p>
      <p><span>居家被动监测：</span>通过智能手机或可穿戴设备在日常生活中自动记录咳嗽事件，量化频率和昼夜节律，生成纵向趋势曲线，从而在病情明显恶化前捕捉早期信号，辅助临床随访与风险分层。</p>
      这一创新模式有望将咳嗽从主观症状转变为可追踪的生物学表型，在进展性肺纤维化（PPF）的早期识别与个体化管理中发挥重要作用。
    </div>
    <div class="size-3">
      五、临床意义与展望
    </div>
    <div>
      <p>
        咳嗽在 ILD 管理中具有双重价值：既是影响患者生活质量的核心症状，也是疾病进展的敏感指标。随着声音监测技术的发展，咳嗽正在成为临床决策的“第四维度”，可在不增加患者负担的情况下，提供连续、客观、可复现的数据，作为影像学和传统肺功能评估的补充。
      </p>
      <p>
        未来，基于多中心研究和真实世界队列的验证，将进一步明确咳嗽音监测在 PPF 早期预警、疗效评估和个体化治疗中的临床价值。
      </p>
    </div>
    <div class="size-3">
      <br><br>
      参考文献：
    </div>
    <div class="color999 font-size14">      
      <p>
      1.McGarvey LPA, Birring SS, Morice AH, et al; COUGH-1 and COUGH-2 Investigators. Efficacy and safety of gefapixant, a P2X_3 receptor antagonist, in refractory chronic cough and unexplained chronic cough (COUGH-1 and COUGH-2): results from two double-blind, randomised, parallel-group, placebo-controlled, phase 3 trials. Lancet. 2022;399(10328):909-923. doi:10.1016/S0140-6736(21)02348-5. <br>
      </p>   
      <p>
      2.van Manen MJG, Birring SS, Vancheri C, et al. The curious case of cough in interstitial lung diseases. Chest. 2022;162(6):1292-1294. doi:10.1016/j.chest.2022.08.010.<br>
      </p>
      <p>
      3.Raghu G, Remy-Jardin M, Myers JL, et al. Idiopathic pulmonary fibrosis (an update) and progressive pulmonary fibrosis in adults: an Official ATS/ERS/JRS/ALAT Clinical Practice Guideline. Am J Respir Crit Care Med. 2022;205(9):e18-e47. doi:10.1164/rccm.202202-0399ST.<br>
      </p>
      <p>
      4.Floria DE, Speer C, Rhee EP, et al. Gastroesophageal reflux and chronic cough: a systematic review and meta-analysis. Sci Rep. 2024;14:21234. doi:10.1038/s41598-024-21234-7.<br>
      </p>
      <p>
      5.Mann JMV, Holland AE, et al. Understanding patient experience of chronic cough in interstitial lung disease. ERJ Open Res. 2023;9(3):00039-2023. doi:10.1183/23120541.00039-2023.<br>
      </p>
      <p>
      6.Podolanczuk AJ, Swigris JJ. Nintedanib and symptoms of fibrotic lung disease. ERJ Open Res. 2024;10(2):00108-2024. doi:10.1183/23120541.00108-2024.<br>
      </p>
      <p>
      7.Swigris JJ, Cutts K, Male N, et al. Responsiveness and meaningful change thresholds of the Living with Pulmonary Fibrosis (L-PF) questionnaire dyspnoea and cough scores in progressive fibrosing interstitial lung diseases. BMJ Open Respir Res. 2022;9(1):e001167. doi:10.1136/bmjresp-2022-001167.<br>
      </p>
      <p>&nbsp;</p>
    </div>
    
  </div>
</div>

<!-- 研究前沿进展-详情2 -->
<div *ngIf="pages == 'home/yjqyjzxq2'" class="bg-fff">
  <div class="d-banner yjqyjz-banner">
    <img src="./assets/new/jzxfbypt_yjqyjz_tittle.png" alt="">
    <div>
      当前位置：<a (click)="goDetails('home','首页')">首页</a> > <a (click)="goDetails('yjqyjz','首页')">研究前沿进展</a>
    </div>
  </div>

  <div class="hzkp-con">
    <div class="size-2 text-indent0">
      间质性肺疾病研究进展
    </div>
    <div class="text-center size-4 text-indent0">尹成胜，徐作军</div>
    <img src="./assets/new/jzxfbypt_yjqyjz_jzxfjbyjjz.png" alt="">
    <div class="mt-4">
      <p>
        <span>摘要：</span>间质性肺疾病是一类累及肺泡和肺间质疾病的总称，临床种类分型多，不同类型预后差距很大，这些都给临床医生诊治此类疾病带来艰巨的挑战。近年来关于间质性肺疾病的临床和基础研究有了很多的新进展。文章就对近年来在纤维化性间质性肺疾病、新型冠状病毒相关间质性肺疾病、结缔组织病相关间质性肺疾病、过敏性肺炎和结节病等常见间质性肺疾病的临床和基础重要新进展进行阐述。<br>
      </p>
      <p>
        <span>关键词：</span>间质性肺炎；肺纤维化；新冠相关间质性肺炎；过敏性肺炎；结节病<br>
      </p>
      <p>
        <span>中图分类号：R575 文献标识码：A</span><br>
      </p>
    </div>
    <div>
      <p>
      <span>Advance of interstitial lung disease in recent years</span> YIN Cheng- sheng，XU Zuo- jun.Department of Respiratory and Critical Medicine，Peking Union Medical College Hospital，Chinese Academy of Medical Sciences and Peking Union Medical College，Beijing 100730，China<br>
      </p>
      <p>
        Corresponding author：XU Zuo-jun，E-mail：xuzj@hotmail.com<br>
      </p>
      <p>
        <span>Abstract：</span>Interstitial lung disease is a group of diseases，involving alveoli and pulmonary interstitium. The large number of clinical types and the great difference in prognosis among different types pose a formidable challenge to clinicians in diagnosing and treating these diseases. In recent years，there have been many new advances in the clinical and basic research in this area. In this article，we summarize the important new developments in the clinical and basic research in ibrotic interstitial lung disease，post COVID- 19 related interstitial lung disease，connective tissue disease- related interstitial lung disease，allergic pneumonia and sarcoidosis in recent years.<br>
      </p>
      <p>
        <span>Keywords：</span>interstitial lung disease；pulmonary fibrosis；post COVID- 19 related interstitial lung disease；hypersensitive pneumonitis；sarcoidosis<br>
      </p>
    </div>
    <div>
      间质性肺疾病（interstitial lung disease，ILD）是一组累积肺泡、肺间质的疾病，病理表现为肺泡、肺间质的慢性炎症或纤维化，临床表现为进行性肺功能下降和弥散功能障碍，进而导致呼吸衰竭和死亡，病种分类可以多达200多种<sup>[1-2]</sup>。本文将对近年来几种常见ILD的重要进展进行综述。<br>
    </div>

    <div class="size-3">
      1 纤维化性间质性肺疾病（fibrotic-ILD，f-ILD）
    </div>
    <div>
      <p>
        f-ILD是一组以肺间质的明显纤维化伴炎症为病变特征的ILD。特发性肺纤维化（idiopathic pulmonary fibrosis，IPF）是最常见的f-ILD。<br><br>
      </p>
      <p class="size-5">
          基金项目：中央高水平医院临床科研基金（2022-PUMCH-B-108）；国家自然科学基金（82070067）
      </p>
      <p class="size-5">
          作者单位：中国医学科学院北京协和医学院 北京协和医院呼吸和危重症医学科，北京 100730
      </p>
      <p class="size-5 mb-4">
          通信作者：徐作军，电子信箱：xuzj@hotmail.com
      </p>

      <p>
        目前的观点认为肺纤维化是由上皮细胞损伤驱动瘢痕修复，导致上皮细胞功能障碍和间质转化<sup>[3]</sup>。但是近年来研究提出了很多新概念，包括上皮细胞、成纤维细胞和免疫细胞的衰老，线粒体功
能障碍与线粒体活性氧生成和渗漏，端粒不稳定和内质网应激引起的DNA损伤和家族遗传性的短端粒综合征等<sup>[4-5]</sup>。值得注意的是2023年欧洲呼吸病协会（European Respiratory Society，ERS）提出IPF有明显的遗传易感性，是其他 ILD10 倍左右<sup>[6]</sup>。建议有如下情况患者行基因测序：（1）纤维化性ILD患者的家族中存在≥1 个纤维化性 ILD 的一级或二级家庭成员时；（2）ILD 患者的亲属中有携带已知的致ILD或可能致ILD的基因突变时；（3）疑似短端粒综合征的患者；（4）&lt;50岁的纤维化性ILD。CHEST杂志也发表了肺纤维化疾病基因测序诊治规范的指导文章，建议对于可疑的遗传性ILD行常规基因检测<sup>[7]</sup>。我们研究团队通对226例中国IPF患者进行全外显子测序发现了在GO和KEGG通路富集的36个候选基因并绘制了罕见蛋白编码变异的全面突变图谱，这些候选基因主要与细胞黏附和免疫反应相关，部分解释IPF中免疫相关通路相关基因表达的变化，找到了中国IPF患者可能的遗传易感基因<sup>[8]</sup>。<br><br>
      </p>
      <p>
        目前IPF的诊断仍是推荐基于汇集临床、影像、病理的多学科讨论模式（multidisciplinary discussion，MDD），近期中华医学会间质性肺疾病学组发表的间质性肺疾病多学科讨论规范中国专家共识中进一步强调了MDD在ILD诊断中的重要性，并且规范了MDD的基本形式和内容<sup>[2]</sup>。在2022年更新的 ATS/ERS/JRS 关于 IPF 的工作指南中强调在 IPF诊断流程中：将 HRCT 的可能寻常间质性肺炎（usual interstitial pneumonia，UIP）型等同于 UIP 型对待，即可能UIP型的也不需要安排肺活检，综合临床特征、化验等资料经 MDD 后可诊断IPF<sup>[3]</sup>。在综合HRCT影像学表型和肺组织活检病理表型时，非UIP型的HRCT患者，若经肺组织活检，病理提示可能 UIP 型则诊断不确定的 IPF，但在 2018 年版的指南中则认为是非IPF。同时强调的UIP的影像学表现也可以出现在其他 ILD 中，在诊断 IPF 时需要排除其他表现为 UIP 的纤维化型 ILD，如纤维化型过敏性肺炎（fibrotic hypersensitive pneumonia，FHP）、结缔组织病相关间质性肺疾病（connective tissue disease related interstitial lung disease，CTD-ILD）和职业暴露相关的ILD等。<br><br>
      </p>
      <p>
        非 IPF 的进展性肺纤维化（progressive pulmonary fibrosis，PPF）是近年来提出的概念，2022 年更新的ATS/ERS/JRS关于IPF的工作指南进一步明确定义了PPF的诊断标准<sup>[3]</sup>。标准指出在近1年内出现≥2 项如下表现的非 IPF-FILD 患者可诊断为PPF：（1）咳嗽、气短等呼吸系统症状恶化；（2）肺功能下降：1年内用力肺活量(FVC)占预计值百分比下降>5%，和（或）1年内弥散功能（DLCO）（经血色素校正后）占预计值百分比下降>10%；（3）胸部影像学进展（≥1项）：牵张性支气管扩张或细支气管扩张范围增大或程度加剧；新发磨玻璃影伴有牵张性细支气管扩张；新发细网格影；网格影的范围增大或程度加剧；新发蜂窝影或原有蜂窝影加剧；肺容积进一步缩小。PPF 的类型 INSIGHTS- ILD 报道了德国246 例 PPF 患者的临床分型结果：特发性间质性肺炎（FIIP或IIP）占21.1%，过敏性肺炎（HP）占25.6%，系统性硬化症相关ILD占12.2%，无法分类的ILD占11.8%，类风湿关节炎相关 ILD 占 12.2%，其他自身免疫性疾病相关 ILD 占 14.2%<sup>[9]</sup>。有研究总结 ILD发展为PPF的危险因素有以下可能：HP抗原的持续暴露、基线时严重呼吸困难、体格检查时出现Velcro音、静息状态SpO<sub>2</sub>≤94%<sup>[10]</sup>。<br><br>
      </p>
      <p>
        关于肺纤维化的药物治疗，目前批准的治疗药物仍然只有吡啡尼酮和尼达尼布<sup>[11]</sup>。对于 PPF 的治疗国内外的指南都建议进行规范的抗纤维化治疗，以吡啡尼酮和尼达尼布为代表的抗纤维化药物在相关的临床研究中被证明是能使患者获益<sup>[12]</sup>。目前正在开展抗纤维化药物的临床研究有磷酸二酯酶 4（PDE4）抑制剂、溶血磷脂酸（LPA）抑制剂、PRM-151（穿透素）、amrevulumab（抗CTGF的单克隆抗体）。虽然 PRM-151、Pamrevulumab 在近期已经宣布临床试验失败，但这些正在开展的药物试验为抗肺纤维化提供了更多选择的可能<sup>[13-14]</sup>。<br>
      </p>
    </div>
    <div class="size-3">
      2 新冠病毒感染相关的 ILD（post Covid-19 ILD，PC-ILD）
    </div>
    <div>
      <p>
        作为近几年来最大的公共卫生事件，新型冠状病毒感染导致间质性肺炎以及肺纤维化引起了广泛的关注。相关的研究报道，新冠病毒感染的肺炎病理学呈现为弥漫性的肺泡损伤、炎症细胞浸润、
纤维素渗出以及机化或胶原沉积，呈现为间质性肺疾病样的改变<sup>[15-16]</sup>。在新冠肺炎早期的影像主要表现为以斑片磨玻璃表现为主，有些可以表现有小叶间隔增厚，甚至表现为铺路石征。重症患者的肺部均有受累，大部分表现为机化型肺炎（OP）、非特异性间质性肺炎（NSIP）和实变影。在恢复期大部分轻症患者肺部病变可以吸收，部分患者可以看到一些不规则的索条影、网格、甚至牵拉支气管扩张等一些纤维化的改变。Huang等<sup>[17]</sup>对1 276例COVID-19感染的幸存者进行随访，12个月后危重患者中因肺 间 质 病 变 引 起 弥 散 损 害 的 发 生 率 高 达 54%（38/70）。 武 汉 金 银 坛 医 院 和 武 汉 中 心 医 院 对COVID-19重症感染患者的随访发现出院1年后高达 66.1%的患者有持续性肺部纤维化的影像表现<sup>[18]</sup>。总体来说COVID-19感染后，特别是重症感染的患者，感染康复后仍有持续性的肺纤维化和临床症状。目前关于新冠病毒感染相关的肺间质病变概念不统一，有新冠感染的间质性肺炎、新冠感染肺纤维化、新冠感染后间质性肺疾病等不同的概念。笔者认为鉴于新冠病毒感染引起的肺间质病变有多种表现，用新冠感染相关间质性肺疾病（PostCovid-19 ILD，PC-ILD）比较合适。<br><br>
      </p>
      <p>
        新冠感染相关ILD具体机制目前仍未明确，目前的研究认为是病毒损伤肺泡上皮细胞时释放细胞炎症因子，如肿瘤生长因子-β（TGF-β）、白细胞介素-6（IL-6）、C-X-C基序趋化因子配体12（CXCL12），这些细胞炎症因子有助于免疫细胞（巨噬细胞、SatM 和嗜中性粒细胞）的激活和募集<sup>[19]</sup>。过度的细胞炎症因子反应和免疫细胞的过度激活进而导致成纤维细胞被大量募集和激活，通过EMT转化为肌成纤维细胞和细胞外基质沉积，这种异常的疤痕性修复最终导致肺纤维化<sup>[20]</sup>。2021 年发表在CELL 杂志上的文章中研究者通过对 2 个 COVID-19感染的呼吸窘迫综合征队列患者样本进行单细胞测序、免疫组化和电镜观察发现，COVID-19具有显著增高的促纤维化表型的 CD163 高表达的肺泡巨噬细胞，这种表型与IPF中的单核细胞表型一致，提示新冠感染的肺纤维化可能与IPF有共同的基础机制<sup>[21]</sup>。<br><br>
      </p>
      <p>
        关于新冠相关的ILD是否需要抗纤维化治疗目前尚无明确的循证医学证据，临床工作中应该针对不同患者的具体情况进行具体对待，进行精确化管理，指南建议在纤维化早期，特别是在炎症渗出期，影像表现为OP和NSIP的急性加重时建议使用糖皮质激素治疗<sup>[22]</sup>。对于抗纤维化的治疗，相关的临床试验结果吡啡尼酮和尼达尼布有能够延缓 FVC 的下降、改善患者活动耐受量、减轻胸闷症状的潜在临床获益<sup>[23-24]</sup>。但目前指南没有提出新冠感染肺纤维化的抗纤维化治疗规范，需要针对这类患者设计更多的前瞻性研究。<br>
      </p>
    </div>
    <div class="size-3">
      3 结缔组织病相关的ILD
    </div>
    <div>
      <p>
        ILD 是结缔组织病最常见的合并症之一，是影响CTD 生存期的重要危险因素<sup>[25]</sup>。2023年的一项荟萃分析，总结出不同类型的CTD合并ILD的患病率为：类风湿关节炎11%（95% CI 7%~ 5%），系统性硬化 47%（44%~ 50%），特发性炎症性肌炎 41%（33% ~ 50%），原发性 Sjögren 综合征 17%（12% ~21%），混合性结缔组织病56%（39%~ 72%），系统性红斑狼疮 6%（3%~ 10%）<sup>[26]</sup>。不同 CTD 亚型的 ILD的影像表现不同，UIP 在类风湿相关的 ILD 中比较常见，其他类型的CTD-ILD更多的表现为NSIP。<br><br>
      </p>
      <p>
        近年来发表了很多关于 CTD-ILD 的生物标志物的研究，这些研究认为阳性血清学标志物和炎症标志物是 CTD-ILD 发生的高危风险因素。南京的队列研究结果指出 37.1%的抗 Ro52 阳性 CTD 患者发生ILD，其中特发性炎症性肌病（IIM）是最常见的（85.4%），抗 Ro52 单阳性的 CTD 和非 CTD 患者 ILD的发生率均增加（OR 4.94，P&lt;0.0001，OR 3.41，P&lt;0.05）<sup>[27]</sup>
。北京协和医院关于IM-ILD的血清学研究结果也提出Ro52抗体与ILD明确相关，应对孤立的Ro52 抗体阳性患者在诊断之初进行肌炎抗体谱的筛查评估<sup>[28]</sup>。对已经通过HRCT表现为UIP或可能UIP诊断为IPF的患者，如随访过程中出现发热、消瘦、关节疼痛、肾功能受损症状时应及时复查自身抗体警惕血管炎相关的UIP可能<sup>[29]</sup>。<br><br>
      </p>
      <p>
        关于CTD-ILD治疗方面强调双重达标治疗，一方面强调控制原发病，另一方面需给予抗纤维化治疗。除了传统的免疫抑制剂治疗外，近年来非常规合成改善病情抗风湿药物（ncs-DMARD）如阿巴西
普、利妥昔单抗、托珠单抗、肿瘤坏死因子和JAK抑制剂等为治疗 CTD-ILD 提供了新的选择<sup>[30]</sup>。最近的一项系统综述和荟萃分析指出 ncs-DMARDs 单药或联合常规治疗可能是稳定或改善RA-ILD患者ILD 的最有效治疗方法<sup>[31]</sup>。有研究结果提出使用JAK抑制剂托法替布能使无肌病型皮肌炎相关间质性肺疾病患者的FVC、DLCO和HRCT上的病变范围明显改善<sup>[32]</sup>。在治疗快速进展型ILD时JAK抑制剂效果也优于糖皮质激素、环磷酰胺、环孢素等传统免疫抑制剂<sup>[33]</sup>。因CTD-ILD纤维化进程同IPF的发病机制存在一定相似之处，抗纤维化药物吡非尼酮、尼达尼布推荐应用于CTD-ILD的抗纤维化治疗中<sup>[11，30]</sup>。另外这些研究也提出对于急性加重难治的CTD-ILD，生物制剂、血浆置换、造血干细胞移植等能改善 CTD 的预后的新治疗方案，也可以为 CTD-ILD的临床治疗提供了新的思路<sup>[34]</sup>。<br>
      </p>
    </div>
    <div class="size-3">
      4 过敏性肺炎（hypersensitive pneumonitis，HP）
    </div>
    <div>
      <p>
        近年来ATS/JRS/ALAT<sup>[35]</sup>和CHEST<sup>[36]</sup>都更新了HP的指南。更新的指南最重要的变化是提出不再强调急性和慢性 HP 的区别，认为是否有纤维化才是区分预后的重要标志<sup>[37]</sup>。建议将HP分FHP和非FHP。非FHP表现为炎症的特征，影像表现为小气道受累的小叶中心结节和空气潴留，弥漫性分布的实质磨玻璃样阴影，组织病理学诊断需符合细胞性间质性肺炎、细胞性细支气管炎和形成不良的非坏死性肉芽肿3条标准。FHP最常表现为不规则网状影，伴肺泡扭曲，伴小叶间隔增厚，单独或GGO区域的牵拉性支气管扩张，严重的纤维化可以表现为广泛性的蜂窝肺。这种纤维化的表现主要在中部或中下肺部，基底通常不是很明显。建议行肺泡灌洗（BAL）对灌洗液进行淋巴细胞流式分析做辅助诊断，必要时可行经支气管肺活检或手术肺活检病理确诊。<br><br>
      </p>
      <p>
        2021 CHEST更新HP诊断指南重点概述了病理特征<sup>[36]</sup>。指南将HP组织学标准分为4个诊断类别：（1）典型的FHP或非FHP;（2）与非FHP或FHP兼容;（3）不确定非 FHP 或 FHP;（4）替代诊断。与 ATS 指南不同的是CHEST 指南增加了炎症浸润应主要由淋巴细胞组成的标准。在CHEST指南中“与HP相容”用于第二级组织学分类，ATS 指南属于“可能HP”。 ATS分类是基于纳入标准，要求存在HP特有的组织学特征，而CHEST标准基于排除标准更有利于诊断不典型的HP病例。<br>
      </p>
    </div>
    <div class="size-3">
      5 结节病（sarcoidosis）
    </div>
    <div>
      <p>
        2020年ATS更新的结节病指南中，结节病的诊断标准仍然为排他性诊断，病理排除其他原因的非坏死性肉芽肿性炎症即可诊断为结节病<sup>[38]</sup>。发病机制方面，2021年有研究综述总结提出结节病是一种自身免疫性疾病，是T淋巴细胞在分化阶段通过与先天免疫系统细胞的相互作用激活对自身蛋白质的免疫反应<sup>[39]</sup>。也有认为环境职业暴露与发病率有关，微生物如丙酸杆菌属、分枝杆菌的感染可能有助于结节病发生和发展<sup>[40]</sup>。有趣的是泰国报道了 1 例 COVID-19 感染后诊断结节病的病例，患者感染COVID-19康复10周后胸部 CT显示双侧肺门、肺旁和隆突下淋巴结肿大、双眼全葡萄膜炎和视乳头炎，淋巴节病理结果为形成良好的非坏死性肉芽肿诊断为结节病<sup>[41]</sup>。报道认为COVID-19感染后发生结节病的可能机制是病毒感染的炎症过程与引起结节发生的自身免疫失调之间有联系。<br><br>
      </p>
      <p>
        另外 2020 年的 ATS 指南强烈建议结节病患者接受基线血清钙检查，近一半高钙血症的结节病会发展成不可逆转的肾功能衰竭，建议早期干预预防肾衰竭<sup>[42]</sup>。对于不明原因的高度房室传导阻滞、室性心律失常的患者，需要考虑心脏结节病的可能，建议进一步行 PET-CT、心肌增强核磁等检查来辅助诊断，一旦诊断，建议激素联合免疫抑制剂治疗<sup>[40]</sup>。<br><br>
      </p>
      <p>
        总之，ILD 是一类异质性特别大的疾病，其病因繁多，临床表现缺乏特异性，影像、病理改变复杂多样，临床诊断难度大，不能进行早诊断早治疗而临床预后很差。目前ILD的诊断仍是基于呼吸危重症医学科、影像/放射科和病理科（建议有条件包含风湿免疫科、血液科、胸外科和呼吸护理与康复的专家）参与的 MDD 模式进行诊断。尽管当前关于ILD的研究较前有了长足的发展，但目前待解决的问题仍然很多，包括不限于发病机制、新一代的更有效的治疗药物、有效的诊断和评估病情的生物标志物、借助人工智能对病变类型和范围的定性定量识别等研究。
      </p>
    </div>

    <div class="size-3">
      <br><br>
      参考文献：
    </div>
    <div class="color999 font-size14">        
      <p>
      ［1］ Wijsenbeek M，Suzuki A，Maher TM. Interstitial lung diseases［J］.Lancet，2022，400（10354）：769-786. <br>
      </p>   
      <p>
      ［2］中华医学会呼吸病学分会，中国医师协会呼吸医师分会.间质性肺疾病多学科讨论规范中国专家共识［J］.中华结核和呼吸杂志，2023，43（10）：827-833.<br>
      </p>
      <p>
      ［3］ Raghu G，Remy- Jardin M，Richeldi L，et al. Idiopathic pulmonary fibrosis（an update）and progressive pulmonary fibrosis in adults： an Official ATS/ERS/JRS/ALAT Clinical Practice Guideline［J］. Am J Respir Crit Care Med，2022，205（9）：e18-e47.<br>
      </p>
      <p>
      ［4］ Moss BJ，Ryter SW，Rosas IO. Pathogenic mechanisms underlying idiopathic pulmonary fibrosis［J］. Annu Rev Pathol，2022，17：515-546.<br>
      </p>
      <p>
     ［5］Kropski JA，Blackwell TS. Endoplasmic reticulum stress in the pathogenesis of fibrotic disease［J］. J Clin Invest，2018，128（1）：64-73.<br>
      </p>
      <p>
      ［6］Borie R，Kannengiesser C，Antoniou K，et al. European Respiratory Society statement on familial pulmonary fibrosis［J］. Eur Respir J，2023，61（3）：2201383.<br>
      </p>
      <p>
      ［7］Newton CA，Oldham JM，Applegate C，et al. The role of genetic testing in pulmonary fibrosis：a perspective from the Pulmonary Fibrosis Foundation Genetic Testing Work Group［J］. Chest，2022，162（2）：394-405.<br>
      </p>
      <p>
        ［8］ Fang C，Huang H，Feng Y，et al. Whole- exome sequencing identifies susceptibility genes and pathways for idiopathic pulmonary fibrosis in the Chinese population［J］. Sci Rep，2021，11（1）：1443.<br>
      </p>
      <p>
        ［9］Kreuter M，Prasse A，Guenther AU，et al. Insights on the management and outcomes of patients with progressive fibrosing interstitial lung disease in clinical practice：INSIGHTS- ILD Registry. A38. ADVANCING OUR UNDERSTANDING AND TREATMENT OF ILD［M］.London：Springer，2023：A1479-A1479.<br>
      </p>
      <p>
        ［10］ Silva SAEH，Neto PMC，Mancuzo EV，et al. Progression in fibrotic interstitial lung diseases - prevalence and indicators in
the initial evaluation in a Brazilian multicentric cohort. A38. ADVANCING OUR UNDERSTANDING AND TREATMENT OF ILD［M］.London：Springer，2023：A1497-A1497.
      </p>
      <p>
        ［11］Distler O，Highland KB，Gahlemann M，et al. Nintedanib for systemic sclerosis-associated interstitial lung disease［J］. N EnglJ Med，2019，380（26）：2518-2528.</p>
      <p>［12］ Law A，Walkey AJ，Hawkins FJ，et al. Comparative effectiveness of nintedanib and pirfenidone in patients diagnosed with idiopathic pulmonary fibrosis. A94. Advances In Health Services Research Focused On Interstitial Lung Disease And Cystic Fibrosis［M］. London：Springer，2023：A2481-A2481.</p>
      <p>［13］Richeldi L，Fernandez PE，Costabel U，et al. Pamrevlumab，an anti- connective tissue growth factor therapy， for idiopathic pulmonary fibrosis（PRAISE）：a phase 2，randomised，doubleblind，placebo- controlled trial［J］. Lancet Respir Med，2020，8 （1）：25-33.</p>
      <p>［14］Bonella F，Spagnolo P，Ryerson C. Current and future treatment landscape for idiopathic pulmonary fibrosis［J］. Drugs，2023，83 （17）：1581-1593.</p>
      <p>［15］Wang D，Hu B，Hu C，et al. Clinical characteristics of 138 hospitalized patients with 2019 novel coronavirus- infected pneumonia in Wuhan，China［J］. JAMA，2020，323（11）：1061-1069.</p>
      <p>［16］张凤芹，窦欣然，张惠兰. 新型冠状病毒感染后间质性肺疾病［J］. 中国实用内科杂志，2023，43（9）：714-717.</p>
      <p>［17］Huang L，Yao Q，Gu X，et al. 1- Year outcomes in hospital survivors with COVID- 19：a longitudinal cohort study［J］. Lancet，2021，398（10302）：747-758.</p>
      <p>［18］ Han X，Fan Y，Alwalid O，et al. Fibrotic interstitial lung abnormalities at 1- year follow- up CT after severe COVID-19［J］. Radiology，2021，301（3）：E438-E440.</p>
      <p>［19］Parimon T，Espindola M，Marchevsky A，et al. Potential mechanisms for lung fibrosis associated with COVID- 19 infection［J］. QJM，2023，116（7）：487-492.</p>
      <p>［20］ Giacomelli C，Piccarducci R，Marchetti L，et al. Pulmonary fibrosis from molecular mechanisms to therapeutic interventions：lessons from post-COVID-19 patients［J］. Biochem Pharmacol，2021，193：114812.</p>
      <p>［21］Wendisch D，Dietrich O，Mari T，et al. SARS-CoV-2 infection triggers profibrotic macrophage responses and lung fibrosis［J］. Cell，2021，184（26）：6243-6261.</p>
      <p>［22］中国研究型医院学会呼吸病学专业委员会，北京中西医结合学会呼吸病分会.新型冠状病毒感染引起的肺间质病变诊断和治疗专家建议［J］. 中华结核和呼吸杂志，2020，43（10）：827-833.</p>
      <p>［23］Umemura Y，Mitsuyama Y，Minami K，et al. Efficacy and safety of nintedanib for pulmonary fibrosis in severe pneumonia induced by COVID- 19：an interventional study［J］. Int J Infect Dis，2021，108：454-460.</p>
      <p>［24］Acat M，Yildiz GP，Oner S，et al. Comparison of pirfenidone and corticosteroid treatments at the COVID- 19 pneumonia with the guide of artificial intelligence supported thoracic computed tomography［J］. Int J Clin Pract，2021，75（12）：e14961.</p>
      <p>［25］Hyldgaard C，Bendstrup E，Pedersen AB，et al. Interstitial lung disease in connective tissue diseases：survival patterns in a population-based cohort［J］. J Clin Med，2021，10（21）：4830.</p>
      <p>［26］ Joy GM，Arbiv OA，Wong CK，et al. Prevalence，imaging patterns and risk factors of interstitial lung disease in connective tissue disease：a systematic review and meta- analysis［J］. Eur Respir Rev，2023，32（167）：220210.</p>
      <p>［27］Wu S，Tang X，Wu L，et al. Association of anti-Ro52 autoantibodies with interstitial lung disease in connective tissue diseases［J］. Ann Rheum Dis，2021，80（9）：e151.</p>
      <p>［28］Shao C，Sun Y，Huang H，et al. Myositis specific antibodies are associated with isolated anti- Ro- 52 associated interstitial lung disease［J］. Rheumatology（Oxford），2022，61（3）：1083-1091.</p>
      <p>［29］ 谭春婷，吴晓华，徐岩，等. 特发性肺纤维化与髓过氧化物酶-抗中性粒细胞胞质抗体相关血管炎相关肺纤维化的临床特征
      比较［J］. 中国实用内科杂志，2023，43（6）：491-496.</p>
      <p>［30］邹庆华，路跃武，周京国，等. 结缔组织病相关间质性肺疾病诊疗规范［J］. 中华内科杂志，2022，61（11）：1217-1223.</p>
      <p>［31］Yuan H，Cui S，Yang L，et al. Efficacy of non- conventional synthetic DMARDs for patients with rheumatoid arthritisassociated interstitial lung disease：a systematic review and meta-analysis［J］. RMD Open，2023，9（4）：e003487.</p>
      <p>［32］Chen Z，Wang X，Ye S. Tofacitinib in amyopathic dermatomyositis- associated interstitial lung disease［J］. N Engl J Med，2019，381（3）：291-293.</p>
      <p>［33］Kato M，Ikeda K，Kageyama T，et al. Successful treatment for refractory interstitial lung disease and pneumomediastinum with multidisciplinary therapy including tofacitinib in a patient with anti- MDA5 antibody- positive dermatomyositis ［J］. J Clin Rheumatol，2021，27（8S）：S574-S577.</p>
      <p>［34］ 霍荣秀，郭乾育，许珂. 药物治疗结缔组织病相关间质性肺疾病的进展［J］. 中华风湿病学杂志，2022，26（7）：489-493.</p>
      <p>［35］ Raghu G，Remy- Jardin M，Ryerson CJ，et al. Diagnosis of hypersensitivity pneumonitis in adults. An Official ATS/JRS/ALAT Clinical Practice Guideline［J］. Am J Respir Crit Care Med，2020，202（3）：e36-e69.</p>
      <p>［36］ Fernandez PE，Travis WD，Lynch DA，et al. Diagnosis and evaluation of hypersensitivity pneumonitis：CHEST Guideline and Expert Panel Report［J］. Chest，2021，160（2）：e97-e156.</p>
      <p>［37］Salisbury ML，Gu T，Murray S，et al. Hypersensitivity pneumonitis：radiologic phenotypes are associated with distinct survival time and pulmonary function trajectory［J］. Chest，2019，155（4）：
      699-711.</p>
      <p>［38］ Crouser ED，Maier LA，Wilson KC，et al. Diagnosis and detection of sarcoidosis. An Official American Thoracic Society Clinical Practice Guideline［J］. Am J Respir Crit Care Med，2020，201（8）：e26-e51.
      </p>
      <p>
        ［39］Drent M，Crouser ED，Grunewald J. Challenges of sarcoidosis and its management［J］. N Engl J Med，2021，385（11）：1018-1032.
      </p>
      <p>
        ［40］Belperio JA，Shaikh F，Abtin FG，et al. Diagnosis and treatment of pulmonary sarcoidosis：a review［J］. JAMA，2022，327（9）：856-867.
      </p>
      <p>
        ［41］ Somboonviboon D，Wattanathum A，Keorochana N，et al. Sarcoidosis developing after COVID - 19：a case report［J］. Respirol Case Rep，2022，10（9）：e01016.
      </p>
      <p>
        ［42］ Sexton DJ，O'Reilly MW，Geoghegan P，et al. Serum fibroblastic growth factor 23 in acute sarcoidosis and normal kidney function［J］. Sarcoidosis Vasc Diffuse Lung Dis，2016，33（2）：139-142.
      </p>
      <p>&nbsp;</p>
    </div>    
  </div>
</div>

<!-- 研究前沿进展-详情3 -->
<div *ngIf="pages == 'home/yjqyjzxq3'" class="bg-fff">
  <div class="d-banner yjqyjz-banner">
    <img src="./assets/new/jzxfbypt_yjqyjz_tittle.png" alt="">
    <div>
      当前位置：<a (click)="goDetails('home','首页')">首页</a> > <a (click)="goDetails('yjqyjz','首页')">研究前沿进展</a>
    </div>
  </div>

  <div class="hzkp-con">
    <div class="size-2 text-indent0">
      系统性自身免疫性风湿病患者间质性肺疾病的筛查与监测和治疗
    </div>
    <div class="text-center">——2023年美国风湿学会/美国胸科医师学会指南摘译</div>
    <img src="./assets/new/jzxfbypt_yjqyjz_xtxzsmyjczl.png" alt="">
    <div class="size-4 my-4">
      <p>
        何炎芮 王平 尹成胜 徐作军<br>
      </p>
      <p>
        中国医学科学院 北京协和医院呼吸与危重症医学科，北京100730<br>
      </p>
      <p>
        通信作者：徐作军，Email： xuzj@hotmail.com<br>
      </p>
    </div>
    <div>
      <p>
      <span>【摘要】</span>美国风湿病学会（ACR）/美国胸科医师学会（ACCP）组织了由风湿病学家、呼吸病学家、放射学家等组成的多学科团队，对系统性自身免疫性风湿病患者（systemic autoimmune rheumatic diseases，SARDs）合并间质性肺疾病（interstitial lung disease，ILD）的筛查、监测和治疗提供基于证据的推荐意见。涵盖SARD‑ILD的高危因素、筛查和监测方法和频次，以及一线治疗、一线治疗后ILD进展和快速进展性ILD的治疗选择。推荐意见分两部指南发表，本文对主要内容进行摘译总结。<br><br>
      </p>
    </div>
    <div>
      <p>
        间质性肺疾病（interstitial lung disease， ILD）以肺间质的炎症和（或）纤维化为特征，是系统性自身免疫性风湿病（systemic autoimmune rheumatic disease，SARD）患者发病和
死亡的重要原因。虽然SARD一般均有ILD风险，但类风湿关节炎（rheumatoid arthritis，RA）、系统性硬化症（systemic sclerosis，SSc）、特 发 性 炎 性 肌 病（idiopathic inflammatory 
myopathies，IIM，包括多发性肌炎、皮肌炎、免疫介导的坏死性 肌 病 和 抗 合 成 酶 综 合 征）、混 合 结 缔 组 织 病（mixed connective tissue disease，MCTD）和 干 燥 综 合 征（Sjögren disease，SjD）风险特别高，因此本指南旨在为此 5 种患者的ILD筛查、监测、治疗提供建议。<br>
      </p>
    </div>
    <div class="size-3">
      一、方法
    </div>
    <div>
      <p>        
      美国风湿病学会（American College of Rheumatology，ACR）和 美 国 胸 科 医 师 学 会（American College of Chest Physicians， ACCP）共同制定对具有 ILD 高风险的 SARD 患
者进行筛查和监测指南［1］，以及对SARD‑ILD患者的治疗指南［2］，适用于成人RA、SSc、IIM、MCTD和SjD，但不适用于怀孕或哺乳期的个体。指南核心专家团队包括风湿病学专家、呼吸病学家和放射学家，按照 ACR指南制定规则，由核心专家组提出临床问题，采用推荐意见分级评估、制定和评价 方 法（grade of recommendations assessment， development and evaluation，GRADE），通过系统性文献回顾对当前证据进行审查和可信度评级，参考患者代表意见，投票产生推荐意见，做出“强推荐、强不推荐、有条件推荐、有条件不推荐”的建议，每项建议需要70%以上的专家达成一致。
      </p>
    </div>
    <div class="size-3">
      二、SARD‑ILD的筛查和监测
    </div>
    <div>
      <p>筛查对象 ：RA、SSc、IIM、MCTD和SjD常合并ILD。表1总结了此5种SARD患者发生ILD的危险因素，提示临床医生需要加强这些具有ILD风险因素的SARD患者筛查。
但筛查对象不应只限于这些有ILD危险因素的人群，必须个体化，需要医生与患者共同决策。<br><br>
</p>
      <p>筛查方式：对于具有ILD风险因素的SARD患者，有条件推荐胸部高分辨率CT（high‑resolution computed tomography，HRCT）和肺功能联合应用筛查方式，优于应用肺部病史和体格检查或运动低氧饱和度测试或单用肺功能检查筛查方式。有条件不推荐使用胸部 X线片、6 min步行试验、运动低氧饱和度测试或支气管镜进行筛查。若肺功能检查质量不佳时，可考虑使用运动低氧饱和度测试。支气管镜检可以用于除外感染、结节病、淋巴瘤或肺泡出血。强不推荐外科肺活检筛查 ILD，除非怀疑恶性肿瘤时，可考虑进行。<br><br>
</p>
      <p>筛查频率：建议对具有ILD风险因素的SARD患者每年筛查 ILD，此外对于有高 ILD 风险抗体存在的 SARD 患者（如抗 Scl‑70、抗 MDA‑5 和抗合成酶抗体）或出现 ILD 症状/体征患者应考虑在病程早期更频繁的筛查。<br><br>
      </p>
      <div class="zxq3-flex">
          <div>            
            <p class="size-4">
              DOI：10.3760/cma.j.cn112147-20250207-00069
            </p>
            <p class="size-4">
              收稿日期 2025-02-07 本文编辑 蔡蜀菁
            </p>
            <p class="size-4">
              引用本文：何炎芮, 王平, 尹成胜, 等. 系统性自身免疫性风湿病患者间质性肺疾病的筛查与监测和治疗：
            </p>
            <p class="size-4">
              2023 年美国风湿学会/美国胸科医师学会指南摘译[J]. 中华结核和呼吸杂志, 2025, 48(4): 396-400. DOI:
            </p>
            <p class="size-4">
              10.3760/cma.j.cn112147-20250207-00069.
            </p>
          </div>
          <div>
              <img class="img-w1" src="./assets/new/erweima.png" alt="">      
          </div>
      </div>
      <img class="img-w2" src="./assets/new/jzxfbypt_yjqyjz_xtxzsmyxfsb_form1.png" alt="">
      <p class="mt-4">
        监测方式：对于确诊 SARD‑ILD 患者，有条件推荐应用肺功能联合胸部HRCT监测ILD进展情况，优于单用肺功能监测；有条件推荐应用运动低氧饱和度测试监测。有条件不推荐应用 X线胸片、6 min步行试验和支气管镜等方式进行监测；但在特定情况下，可考虑使用，如使用6 min步行试验进行肺移植前监测或作为不能完成肺功能检查时的选择、使用支气管镜检查除外感染或肺泡出血。<br><br>
      </p>
      <p>
        监测频率：对于确诊 SARD‑ILD 患者，ILD 病情监测频率未能形成明确具体的推荐意见，而是给出了一般性建议。对于IIM‑ILD、SSc‑ILD，建议在第 1 年每 3~6 个月监测肺功能，对于RA‑ILD、SjD‑ILD、MCTD‑ILD，建议在第 1 年每 3~12个月监测肺功能，第一年后若病情稳定可减少监测频率如每 6~12 月监测肺功能。监测频率需视病情稳定程度而定，在病程早期、活动性或进展性ILD患者需要更频繁的监测，而如果病情长期稳定则可减少监测频率。SARD‑ILD患者胸高分辨CT监测频率指南未能给出建议，根据临床指征而定。建议每 3~12 个月进行 1 次运动低氧饱和度测试监测。<br><br>
      </p>
      <p>
        图1总结了ILD筛查以及SARD‑ILD病情监测的建议。<br><br>
      </p>
      <p>
        值得注意的是，筛查和监测部分建议证据基本来自小规模观察性研究，证据级别低，一些重要问题还有待进一步研究，如最具成本效益的筛查和监测频次、胸部HRCT监测是否根据组织学类型（如非特异性间质性肺炎和 UIP）而有所差异。此外，需要发掘更多的危险因素，包括扩大自身抗体谱分析。放射学类型、自身抗体谱和（或）其他特征可以共同为SARD‑ILD亚群提供相应的筛查和监测建议。<br><br>
      </p>
    </div>
    <div class="size-3">
      三、SARD‑ILD的治疗
    </div>
    <div>
      <p>
        指南针对SARD‑ILD一线治疗、一线治疗后ILD仍进展的治疗以及快速进展性ILD（rapidly progressive ILD，RP‑ILD）治疗提出 35 条治疗建议，并将一线治疗药物划分为“首选”和“可选”治疗，总结出治疗选择的流程（图 2、3）。同时，指南对药物毒性及监测提供了指导（表 2）；指南同时总结了 SARD‑ILD 患者照护中可考虑的其他药物和综合性干预措施。<br><br>
      </p>
      <img class="img-w3" src="./assets/new/jzxfbypt_yjqyjz_xtxzsmyxfsb_fig1.png" alt="">
      <p>
        （一）SARD‑ILD的一线治疗方案推荐
      </p>   
      <p>
        糖皮质激素：对于非 SSc‑ILD 的 SARD‑ILD 患者，有条件推荐糖皮质激素作为ILD一线治疗。口服糖皮质激素常用于非 SSc‑ILD 的 SARD‑ILD 患者，静脉甲泼尼龙治疗通常用于急性起病或病情较重的患者。但是对于SSc‑ILD患者，        
        <img class="img-w4" src="./assets/new/jzxfbypt_yjqyjz_xtxzsmyxfsb_fig2.png" alt="">
        <img class="img-w5" src="./assets/new/jzxfbypt_yjqyjz_xtxzsmyxfsb_fig3.png" alt="">
        因糖皮质激素与硬皮病肾危象相关 ，特别在泼尼松>15 mg/d（或等效剂量）时，强不推荐一线治疗使用糖皮质激素，如使用也应尽量低于15mg/d。对于具有 SSc 特征的MCTD、具有SSc抗体的IIM‑ILD患者，也应当谨慎使用糖皮质激素作为一线治疗。而对于以纤维化病变为主的SARD‑ILD，如RA‑ILD呈现寻常型间质性肺炎影像模式者，糖皮质激素是否适用有争议。<br><br>
      </p> 
      <p>
        免疫抑制药物：对于 SARD‑ILD 患者，有条件推荐霉酚酸酯、利妥昔单抗、环磷酰胺和硫唑嘌呤作为一线治疗药物。霉酚酸酯的研究数据显示，其疗效与环磷酰胺相当，但不良反应更少，是所有 SARD‑ILD 一线治疗“首选治疗”。根据肺外表现或其他因素包括患者偏好，也可以使用其他一线治疗药物。利妥昔单抗可改善或稳定 FVC，且对炎性关节炎、肌炎或干燥综合征神经病变等有效，有条件推荐为一线治疗“首选治疗”，但需关注感染风险、费用和对疫苗免疫原性的影响。环磷酰胺能够改善或稳定 FVC，但不良反应较其他药物更多，因此作为“可选治疗”而不是“首选治疗”推荐。硫唑嘌呤也有条件推荐作为SARD‑ILD 患者的一线治疗药物，但与其他药物相比有效性证据有限。托珠单抗可使 SSc‑ILD 患者的 FVC 稳定，不良事件发生率低于环磷酰胺，因此对于SSc‑ILD和 MCTD‑ILD，有条件推荐托珠单抗作为ILD 一线治疗药物，特别是在具有炎症表型（C 反应蛋白升高，皮肤进行性增厚）和早期、弥漫性SSc患者可作为一线治疗“首选治疗”，而在 MCTD‑ILD，特别是具有 SSc特征者托珠单抗可作为一线治疗的“可选治疗”。JAK 抑制剂和钙调磷酸酶抑制剂（calcineurin inhibitor， CNI）被有条件推荐作为 IIM‑ILD 的一线治疗选择。有研究表明在非快速进展的 MDA‑5 相关 ILD 患者使用托法替布较他克莫司的病死率更低，因此有条件推荐 JAK 抑制剂作为 IIM‑ILD一线治疗的“可选治疗”药物。观察性研究显示CNI可改善IIM‑ILD，起效迅速且成本较低，有条件推荐作为 IIM‑ILD 一线治疗药物，特别是在 MDA‑5 相关 ILD 或病情较重者，且倾向于认为他克莫司优于环孢素。但对于非 IIM‑ILD 的 SARD‑ILD 患者，由于 JAK 抑制剂和 CNI 应用证据缺乏，有条件不推荐作为一线治疗药物。基于缺少 有 效 性 证 据 和 使 用 经 验 有 限 ，对 于SAR‑ILD 患者，有条件不推荐使用甲氨蝶呤 、来 氟 米 特 、肿 瘤 坏 死 因 子 抑 制 剂（tumor necrosis factor inhibitor， TNFi）和阿巴西普作为一线治疗方案，有条件不推荐 IVIG和血浆置换作为SARD‑ILD的一线治疗。但IVIG对于肌炎和吞咽困难有效，因此在一些急性情况且顾虑感染风险时可考虑应用。<br><br>
      </p>  
      <p>
        抗纤维化药物：尼达尼布可延缓 SSc‑ILD 患者 FVC 下降，但未能达到稳定或改善 FVC 效果，对肺外表现无疗效，存在不良反应（尤其腹泻）以及费用等因素，有条件推荐为SSc‑ILD 的一线“可选治疗”。尼达尼布对 SjD‑ILD、IIM‑ILD和 MCTD‑ILD 患者疗效证据有限，且存在不良反应、费用、首选免疫抑制治疗作为一线治疗等问题，因此有条件不推荐为一线治疗。        
        <img class="img-w5" src="./assets/new/jzxfbypt_yjqyjz_xtxzsmyxfsb_form2.png" alt="">
        委员会对尼达尼布用于 RA‑ILD 患者的一线治疗没有达成共识。由于缺乏有效证据，以及不良反应和经济费用的考虑，指南有条件不推荐使用吡非尼酮作为SARD‑ILD的一线治疗。<br><br>
      </p>
      <p>
        干细胞移植或肺移植：对于 SARD‑ILD 患者，有条件推荐最佳药物治疗作为一线治疗而不是将干细胞移植或肺移植作为一线治疗。<br><br>
      </p>
      <p>
        （二）SARD‑ILD 患者经一线治疗后仍发生 ILD 进展的治疗方案推荐<br><br>
      </p>
      <p>
        糖皮质激素：对于一线治疗后ILD仍进展的SSc‑ILD患者，强不推荐依赖于加用长程糖皮质激素治疗（如>3~6 个月）治疗 ILD 进展，对于非 SSc‑ILD 的其他 SARD‑ILD，有条件不推荐依赖加用长程糖皮质激素治疗。但糖皮质激素可以在病情复发或调整治疗方案作为桥接药物短期应用。<br><br>
      </p>
      <p>
        免疫抑制治疗 ：对 于 一 线 治 疗 后 ILD 仍 进 展 的SARD‑ILD 患者，有条件推荐加用或换用霉酚酸酯、利妥昔单抗、环磷酰胺治疗。早期进展型、弥漫性皮肤受累性、急性期反应物升高的 SSc‑ILD、具有 SSc 表型的 MCTD 以及RA‑ILD，经过一线治疗后ILD仍进展者，有条件推荐加用或换用托珠单抗治疗，其他 SARD‑ILD 则有条件不推荐。IIM‑ILD 患者，特别是抗合成酶综合征或 MDA‑5‑ILD，经一线治疗后ILD仍进展，有条件推荐加用或换用CNI和JAK抑制剂，其他SARD‑ILD则不推荐。IIM‑ILD，以及以肌炎为主要表现的 MCTD‑ILD 患者，一线治疗后 ILD 仍进展者，有条件推荐 IVIG作为治疗选择，例如出现严重呼吸肌无力需要药物快速起效时，IVIG 可能有效。有条件不推荐血浆置换用于SARD‑ILD一线治疗后仍进展的患者。<br><br>
      </p>
      <p>
        抗纤维化药物：经一线治疗后，仍有进展的SARD‑ILD，特别是胸部 HRCT 检查显示有进展性肺纤维化的患者，有条件推荐尼达尼布治疗。RA‑ILD患者经一线治疗后ILD仍进展，尤其是 UIP 类型，由于吡非尼酮可能延缓 FVC 进展，指南有条件推荐使用。其他SARD‑ILD则不推荐。<br><br>
      </p>
      <p>
        干细胞移植或肺移植：有条件推荐经一线治疗后 ILD仍进展的SARD‑ILD患者，转诊至有经验的干细胞移植中心和（或）肺移植中心。<br><br>
      </p>
      <p>
        （三）SARD出现RP‑ILD的治疗方案推荐<br><br>
      </p>
      <p>
        RP‑ILD 是指 ILD 患者在数天至数周内，由室内氧气需求或基线氧气需求，快速恶化到高氧需求或气管插管，且无法用其他原因解释（如感染和心力衰竭）。<br><br>
      </p>
      <p>
        SARD 出现 RP‑ILD 时死亡风险很高，观察性研究表明初始联合治疗可获益。有条件推荐联合治疗而不是单药治疗作为一线治疗方案。一线联合治疗方案通常为糖皮质激素联合一种或两种推荐用于RP‑ILD的药物，尤其是利妥昔单抗、环磷酰胺、IVIG、霉酚酸酯、CNI和 JAK抑制剂。对于病情危重或高度怀疑 MDA‑5阳性患者，推荐糖皮质激素联合上述两种药物治疗。治疗无效的患者，可以考虑联合其他药物。<br><br>
      </p>
      <p>
        糖皮质激素：甲泼尼龙静脉冲击起效快，有条件推荐静脉甲强龙治疗作为RP‑ILD的一线治疗方案，后续序贯大剂量口服泼尼松。在系统性硬化症出现 RP‑ILD 时是否使用糖皮质激素尚无共识，如使用应密切监测肾危象。<br><br>
      </p>
      <p>
        免疫抑制药物：通常与糖皮质激素联用。对 SARD 出现 RP‑ILD 患者，有条件推荐利妥昔单抗、环磷酰胺、IVIG、霉酚酸酯、CNIs和 JAK 抑制剂作为一线治疗选择。利妥昔单抗与环磷酰胺治疗具有相似的病死率和 FVC，而利妥昔单抗起效更早，胃肠道和神经系统疾病的发生率更低。但也有人顾虑利妥昔单抗免疫抑制时间（6个月）相较于环磷酰胺的 1 个月更长，具有更高的感染风险。本指南专家组相较于霉酚酸酯、硫唑嘌呤、CNI、JAK 抑制剂，有条件倾向于将利妥昔单抗作为RP‑ILD的一线治疗，相较于霉酚酸酯和硫唑嘌呤，有条件倾向于环磷酰胺作为RP‑ILD的一线治
疗。除了在 MDA‑5‑RP‑ILD 患者中，相较于环磷酰胺，专家组倾向于利妥昔单抗外，对于其他 SARD 出现 RP‑ILD 专家组未能就环磷酰胺和利妥昔单抗倾向达成共识 。对RP‑ILD 患者，IVIG 联合静脉冲击甲泼尼龙可降低感染风险，尤其是对于病情危重或气管插管的患者，因此尽管有条件推荐利妥昔单抗和环磷酰胺而不是 IVIG 作为 RP‑ILD 一线治疗，但特别关注感染风险可选择 IVIG 作为一线治疗。在 IIM 出现 RP‑ILD 时，他克莫司应用逐渐增多。有条件不推荐甲氨蝶呤、来氟米特、硫唑嘌呤、TNFi、阿巴西普、托珠单抗和血浆置换作为一线RP‑ILD治疗选择。<br><br>
      </p>
      <p>
        抗纤维化药物：对于SARD‑ILD，有条件不推荐使用尼达尼布、吡非尼酮治疗。<br><br>
      </p>
      <p>
        对SARD合并RP‑ILD的患者，考虑到RP‑ILD患者可能无法承受干细胞移植，有条件不推荐干细胞移植作为一线治疗。对SARD患者合并 RP‑ILD，有条件推荐尽早转诊肺移植，而非在经最佳药物治疗无效病情进展后再转诊。<br><br>   
      </p>
      <p>
        各种免疫抑制药物毒性及监测指导见表2。<br><br>
      </p>
      <p>
        指南还总结了 SARD‑ILD 患者照护中可考虑的其他药物和综合性干预措施。药物干预包括治疗胃食管反流、预防肺孢子菌肺炎、促进胃肠动力以及疫苗接种。综合干预措施包括运动、戒烟、姑息治疗、使用气道廓清和深呼吸训练器等物理治疗、肺康复及氧疗等。<br><br>
      </p>
      <p>
        由于大多数推荐因证据有限都是有条件推荐或不推荐，因此在选择推荐方案内的药物时，考虑 ILD 严重程度、进展风险因素、其他临床表现、药物费用和毒性等因素综合决定至关重要。建议在ILD治疗开始时肺科医生共同参与管理，尤其在决定稳定或轻度 ILD 的无症状患者是否需要治疗时。需要与患者明确沟通治疗的潜在毒性，密切随访及时处理可能出现的药物不良反应。<br><br>
      </p>
      <p>
        需要进一步对 SARD‑ILD 的 HRCT 模式、疗效、预测生物标志物等进行研究，为制定更有依据的治疗方案提供证据。<br><br>
      </p>
      <p>
        <b>利益冲突</b> 所有作者声明无利益冲突<br>
      </p>
    </div>
    <div class="size-3">
      <br><br>
      参考文献：
    </div>
    <div class="color999 font-size14"> 
      <p>
      [1] Johnson SR, Bernstein EJ, Bolster MB, et al. 2023 American College of Rheumatology (ACR)/American College of Chest Physicians (CHEST) Guideline for the 
Screening and Monitoring of Interstitial Lung Disease in People with Systemic Autoimmune Rheumatic Diseases [J]. Arthritis Rheumatol, 2024, 76(8): 1201‑1213. DOI:
10.1002/art.42860.<br>
      </p>
      <p>
      [2] Johnson SR, Bernstein EJ, Bolster MB, et al. 2023 American College of Rheumatology (ACR)/American College of Chest Physicians (CHEST) Guideline for the 
Treatment of Interstitial Lung Disease in People with Systemic Autoimmune Rheumatic Diseases[J]. Arthritis Rheumatol, 2024, 76(8): 1182‑1200. DOI: 10.1002/art.42861.<br>
      </p>
      <p>&nbsp;</p>
    </div>    
  </div>
</div>

<!-- 研究前沿进展-详情4 -->
<div *ngIf="pages == 'home/yjqyjzxq4'" class="bg-fff">
  <div class="d-banner yjqyjz-banner">
    <img src="./assets/new/jzxfbypt_yjqyjz_tittle.png" alt="">
    <div>
      当前位置：<a (click)="goDetails('home','首页')">首页</a> > <a (click)="goDetails('yjqyjz','首页')">研究前沿进展</a>
    </div>
  </div>

  <div class="hzkp-con">
    <div class="size-2 text-indent0">
      再评正确理解和规范使用间质性肺疾病相关名词概念
    </div>
    <img src="./assets/new/jzxfbypt_yjqyjz_zpzqljhgf.png" alt="">
    <div class="size-4 my-4">      
      <p>
        陈涛 徐作军<br>
      </p>
      <p>
        中国医学科学院北京协和医院呼吸与危重症医学科，北京100730<br>
      </p>
      <p>
        通信作者：徐作军，Email：xuzj@pumch.cn<br>
      </p>
    </div>
    <div>
      <p>
      <span>【摘要】</span>间质性肺疾病（interstitial lung disease ILD）是种类繁杂的多种疾病的总称，临床诊治过程中涉及很多名词概念，有些名词概念从字面上理解很容易造成错误。另外，随着对ILD研究的不断深入，一些新的名词也不断涌现，临床和科研工作中误解和误用这些名词概念的情况时有发生，给ILD临床诊疗和科研带来极为负面的影响。准确理解和规范使用这些名词概念有助于ILD临床诊疗的规范化和临床研究的同质化。本文主要阐述 5个在 ILD 诊治过程中容易误用的名词概念，包括肺间质异常（interstitial lung abnormality，ILA）、新冠肺炎后肺间质病变（post‑coronavirus interstitial lung disease，PC‑ILD）、进展性肺纤维化（progressive pulmonary fibrosis，PPF）、过敏性肺炎（hypersensitivity pneumonitis，HP）和无法分类的间质性肺病（unclassifiable interstitial lung disease，uILD）。<br>
      </p>
      <p>
        <span>基金项目：</span>中央高水平医院临床科研基金（2022‑PUMCH‑B‑108）；国家自然科学基金（82070067）<br><br>
      </p>
      <p>
        <span>Recomment of the correctly understand and standardize the use of terms and concepts related to interstitial lung disease</span>
      </p>
      <p>
        Chen Tao, Xu Zuojun
      </p>
      <p>
        Department of Pulmonary and Critical Care Medicine, Peking Union Medical College Hospital, Chinese Academy of Medical Sciences & Peking Union Medical College, Beijing 100730, China
      </p>
      <p>
        Corresponding author: Xu Zuojun, Email: xuzj@pumch.cn
      </p>
      <p>
        <span>【Abstract】</span> Interstitial lung diseases (ILD) comprise a group of diseases with varied etiologies and trajectories. Some terminologies in ILD could be easily misapplied in clinical practice if just interpreted literally, which significantly hamper diagnostic accuracy and scientific 
reproducibility. Therefore, correct understanding and appropriate usage of these terminologies are helpful to harmonize clinical practice and research methodologies. This article will elaborate on five noun concepts that are easily misused in the diagnosis and treatment of ILD, including interstitial lung abnormality (ILA), post-coronavirus interstitial lung disease (PC-ILD), progressive pulmonary fibrosis (PPF), hypersensitivity pneumonitis (HP) and unclassifiable interstitial lung 
disease (uILD).
      </p>
      <p>
        <span>Fund program:</span> The National High Level Hospital Clinical Research Funding (2022‑PUMCH‑B‑108); National Natural Science Foundation of China(82070067)<br><br>
      </p>
    </div>
    <div>
      <p>        
      间质性肺疾病（interstitial lung disease ILD）是种类繁杂的多种疾病总称，其所包含的疾病根据病因、临床表现、病理特点等可分不同类别。其中有些名词概念，如过敏性肺炎、脱屑性肺炎等从字面上理解很容易造成错误，因此需要明确其所描述对象，理解背后的发病机制，才能在临床和科研工作中精准使用这些概念。另外，近年来，随着对ILD研究的不断深入，一些新的名词不断被提出，临床和科研工作中误解误用的情况时有发生，因此准确理解和规范使用这些名词概念，对于 ILD 临床诊疗的规范化和临床研究的同质化具有极为重要的意义。笔者在此强调 5个 ILD 相关概念的正确定义与使用。<br><br>
      </p>
    </div>
    <div class="zxq3-flex">
        <div>            
          <p class="size-4">
            DOI：10.3760/cma.j.cn112147-20241218-00745
          </p>
          <p class="size-4">
            收稿日期 2024-12-18 本文编辑 蔡蜀菁
          </p>
          <p class="size-4">
            引用本文：陈涛, 徐作军 . 再评正确理解和规范使用间质性肺疾病相关名词概念[J]. 中华结核和呼吸杂志,
          </p>
          <p class="size-4">
            2025, 48(6): 589-591. DOI: 10.3760/cma.j.cn112147-20241218-00745.
          </p>
        </div>
        <div>
            <img class="img-w1" src="./assets/new/erweima2.png" alt="">      
        </div>
    </div>
    <div class="size-3">
      一、肺间质异常（interstitial lung abnormality， ILA） 
    </div>
    <div>
      <p>ILA是指在无ILD危险因素的群体中，体格检查行胸部影像检查时偶然发现>5%肺野的肺部间质性改变<sup>[1]</sup>。这些间质性改变包括但不限于，磨玻璃及网格影、牵拉性支气管扩张、蜂窝影和非气肿样肺囊腔。根据其影像特点又将其分为非胸膜下型，胸膜下非纤维化型和胸膜下纤维化型，最后一种预后最差，胸膜下纤维化型的影像学表现主要有肺泡结构破坏伴有牵拉性支气管扩张，或者出现蜂窝影。<br><br>
      </p>
      <p>需要特别指出的是：ILA只是用于描述影像学特点的术语，并非某一特定疾病的临床诊断。目前有临床医生把ILA作为临床诊断名称是不准确的。此外，Fleischner学会基于ILA 的定义还提出了以下两个概念：（1）当 ILA 伴随临床症状或者有肺功能检查异常时，可诊断早期ILD；（2）当ILA具有遗传危险因素（家族性 ILD 病史）、职业暴露与自身免疫疾病等 ILD 发病危险因素时，称为亚临床 ILD<sup>[2]</sup>。笔者认为，以上概念过于繁杂，在临床实践中极易混淆，建议从临床角度将无临床症状和肺功能异常的ILA称为亚临床ILD，将有临床症状和（或）肺功能异常的 ILA 称为ILD。针对如何识别可能进行性进展的 ILA，以及何时开始药物干预，是目前急需解决的问题。笔者认为，对于胸膜下分布的纤维化型ILA患者，以及具有家族史、职业暴露和吸烟史的亚临床ILD，临床医生应该加以重视，必要时可以予以干预治疗，而前瞻性临床研究将有助于解决以上问题。<br>
      </p>      
    </div>
    <div class="size-3">
      二 、新冠肺炎后ILD（post‑COVID‑19 interstitial lung disease， PC‑ILD）
    </div>
    <div>
      <p>
        PC‑ILD是指新冠病毒感染急性期过后，病毒转阴，临床症状好转，但胸部影像学检查仍遗留有肺间质病变的情况。新冠病毒流行以来，国内外很多学者将新冠肺炎后胸部影像学的肺间质改变称为新冠感染后肺纤维化（post‑coronavirus pulmonary fibrosis， PCPF），这是不准确的。研究表明，新冠病毒肺炎急性期后3~6个月内，有59%的患者出现PC‑ILD，常见的影像学表现包括磨玻璃影（39%），肺泡间隔增厚（33%），胸膜下纤维条索影（31%），支气管血管束畸形或支气管扩张（26%），胸膜增厚和实变。最常见的影像学特点是非特异性间质性肺炎（nonspecific interstitial pneumonia， NSIP）合并机化性肺炎。但这些影像学异常大部分在糖皮质激素治疗后，可逐渐吸收，只有极少患者可能遗留无法吸收的肺纤维化病灶，这些改变才能称为 PCPF。
文献报道，1%~25% 新冠肺炎患者在随访 1年时，胸部影像学有 PCPF表现<sup>[3]</sup>。另一项研究纳入 106例具有 2年随访资料的新冠患者，结果表明有 22.6% 的患者出现 PC‑ILD，12.2%患者表现为PCPF<sup>[4]</sup>。 因此临床上应注意区分PC‑ILD 与 PCPF 这两个概念。针对 PC‑ILD 患者的治疗，应根据患者肺部遗留间质性病变的范围和性质予以不同的处理，若病灶范围广且影响肺功能，或者病灶以NSIP、OP 为主，应积极予以糖皮质激素为主的治疗；但若病灶为小范围的OP，且经过一段时间随访，病灶具有吸收好转的趋势，可暂不予以药物治疗，密切随访。对于病毒感染前已经有肺纤维化高危因素的患者，包括：长期吸烟史、职业粉尘暴露和自身免疫性疾病等，需要密切随访，警惕发展为 PCPF。针对 PCPF 患者，应区分其是否处于进展期，若确定患者进入进展性肺纤维化阶段，应及时加用抗纤维化药物<sup>[5]</sup>。<br>
      </p>
      <p class="size-3">
        三 、进展性肺纤维化（progressive pulmonary fibrosis，PPF）
      </p>   
      <p>
        2022 年 ATS/ERS 提出了 PPF 概念，PPF 是指除特发性肺纤维化（idiopathic pulmonary fibrosis， IPF）以外的纤维化型 ILD（Fibrotic ILD，fILD）患者，在过去一年内出现以下三
条诊断标准中的至少两条，包括呼吸相关症状加重、肺功能下降、肺部影像表明纤维化进展<sup>[6]</sup>。PPF与进展性纤维化型ILD（progressive fibrosing ILD， PF‑ILD）这一概念虽然都是描述 ILD 病情持续进展，但其所涵盖的疾病种类不同，PF‑ILD 包括 IPF 在内，而 PPF 不包括 IPF；此外 PF‑ILD 的诊断标准也与PPF也略有不同<sup>[7]</sup>。需要特别指出：PPF仅是用来描述纤维化型 ILD 的疾病行为学特征的术语，并不是特定疾病的诊断名称。fILD 是指，肺组织病理具有纤维化特征或者胸部HRCT具有纤维化表现（蜂窝影、牵拉性支气管扩张或小叶内网格影）的ILD患者<sup>[8]</sup>，其包括IPF和非IPF的纤维化型 ILD。在临床实践过程中，在确立 PPF 诊断时，需要特别注意以下 2点：（1）PPF 的诊断应该是建立在 fILD 患者中；（2）PPF 诊断应该在经过规范的针对 ILD 病因治疗后（通常是糖皮质激素和免疫抑制剂），病情仍呈进展者，才可以诊断 PPF。寻找可靠的预测纤维化进展的生物标志物，将简化PPF诊断流程，但由于PPF异质性大，血清标志物似乎难以准确预测不同类型 PPF 患者疾病进展，因此通过多组学分析，构建预测不同类型PPF相关生物学图谱，或许是可行的办法之一。<br>
      </p> 
      <p class="size-3">四、过敏性肺炎（hypersensitivity pneumonitis， HP）</p>
      <p>
        HP也有学者称为外源性过敏性肺泡炎（extrinsic allergic alveolitis， EAA）是指具有过敏体质的患者反复接触过敏原以后出现的免疫介导的间质性肺炎<sup>[9]</sup>。过敏性肺炎名称中的“过敏”，与传统意义上“过敏”不同，传统意义上，过敏是机体再次接触过敏原后，在IgE介导下嗜酸性粒细胞或肥大细胞释放组胺等炎症介质导致的临床表现。这是典型的Ⅰ型超敏反应，是部分支气管哮喘的发病机制。其反应时间短，数分钟内即可发生。而HP发病机制是一种迟发型超敏反应（主要是Ⅲ型超敏反应，少部分是Ⅳ型超敏反应），其反应时间需要 24 h 或者更长，免疫反应过程可能涉及记忆 T细胞和 B细胞，在以上免疫细胞再次接触抗原后，记忆 T细胞增殖分化，形成以 Th1为主的炎症反应，同时记忆B淋巴细胞产生以IgG为主的抗体，介导形成分布在细支气管周围的松散的肉芽肿<sup>[10-11]</sup>。而在反复接触抗原过程中，过度激活的免疫反应和肉芽组织破坏肺泡结构，此时 T细胞免疫反应以Th2和Th17为主，从而启动纤维化进程，最终导致慢性纤维化型 HP。所以过敏性肺炎患者一般是不会有血嗜酸性粒细胞和总 IgE 升高。笔者认为，HP 的发病是机体免疫系统与外界过敏原相互作用的结果，这些致敏原在我们生活的环境中并不罕见，正常人接触以后并不引起超敏反应，只有具有HP遗传易感性的患者接触以后才引起超敏反应。<br>
      </p>  
      <p class="size-3">
        五、无法分类的间质性肺病（unclassifiable interstitial lung disease， uILD）
      </p>
      <p>
        uILD 是指有经验的 ILD 诊疗中心，经过规范的 ILD 多学科讨论（Multidisciplinary discussion MDD）后，仍然无法明确是哪一种病理类型的ILD。国内有人将uILD翻译成未分类型 ILD 是不准确的。从分类来看，uILD 应该归于特发性间质性肺炎（idiopathic interstitial pneumonia， IIP）这一大类。导致 uILD 无法分类的原因有以下两种：（1）无法获取肺组织病理，或者肺组织取材不够，无法明确肺组织病理类型；（2）患者临床表现、肺部影像学特点和肺组织病理特点相互矛盾，无法用一种特定类型的 ILD 解释所有病情<sup>[12]</sup>。需要特别指出的是：uILD是指病理无法分类或经MDD后无法确定是何种病理类型 ILD 的患者，不是指病因不明确的ILD。根据笔者经验，uILD 多见于 CTD‑ILD、IPAF、HP 等患者，因为这些患者病理上往往同时具有UIP、NSIP、OP或LIP等多种重叠表现，故病理无法分类。<br><br>
      </p>
      <p>
        随着人们对 ILD 重视程度的增强和研究的不断深入，一些新概念、新技术以及新诊断方法、新治疗策略、新治疗药物日新月异，临床医生不仅要在临床实践中总结经验，更要及时更新知识，准确应用医学术语，这是对当代临床医生提出的更高要求。<br><br>
      </p>
      <p>
        <span>利益冲突</span> 所有作者声明无利益冲突
      </p>
    </div>
    <div class="size-3">
      <br><br>
      参考文献：
    </div>
    <div class="color999 font-size14"> 
      <p>
      [1] Hatabu H, Hunninghake GM, Richeldi L, et al. Interstitial lung abnormalities detected incidentally on CT: a Position Paper from the Fleischner Society[J]. Lancet Respir Med,2020, 8(7): 726‑737. DOI: 10.1016/S2213‑2600(20)30168‑5.
      </p>
      <p>
      [2] Hata A, Schiebler ML, Lynch DA, et al. Interstitial Lung Abnormalities: State of the Art[J]. Radiology, 2021,301(1):19‑34. DOI: 10.1148/radiol.2021204367.
      </p>
      <p>
        [3] Vasarmidi E, Ghanem M, Crestani B. Interstitial lung disease following coronavirus disease 2019[J]. Curr Opin Pulm Med, 2022, 28(5): 399‑406. DOI: 10.1097/
MCP.0000000000000900.
      </p>
      <p>
        [4] Imtiaz S, Batubara EM, Abuelgasim MH, et al. Long‑term outcome of pulmonary involvement in patients with coronavirus disease 2019: The role of high‑resolution computed tomography and functional status‑A prospective single‑center observational study[J]. Ann Thorac Med, 2024, 19(2):147‑154.
      </p>
      <p>
        [5] Huang H, Wang Q, Xu Z. Advances in the identification and management of progressive pulmonary fibrosis: perspective from Chinese experts[J]. Ther Adv Respir Dis, 2024, 18:17534666241288417. DOI: 10.1177/17534666241288417.
      </p>
      <p>
        [6] Raghu G, Remy‑Jardin M, Richeldi L, et al. Idiopathic Pulmonary Fibrosis (an Update) and Progressive Pulmonary Fibrosis in Adults: An Official ATS/ERS/
JRS/ALAT Clinical Practice Guideline[J]. Am J Respir Crit Care Med, 2022, 205(9): e18‑e47. DOI: 10.1164/rccm.202202‑0399ST.
      </p>
      <p>
        [7] Flaherty KR, Wells AU, Cottin V, et al. Nintedanib in Progressive Fibrosing Interstitial Lung Diseases[J]. N Engl J Med, 2019, 381(18): 1718‑1727. DOI: 10.1056/NEJMoa1908681.
      </p>
      <p>
        [8] Rajan SK, Cottin V, Dhar R, et al. Progressive pulmonary fibrosis: an expert group consensus statement[J]. Eur Respir J, 2023, 61(3): 2103187. DOI:10.1183/13993003.03187-2021.
      </p>
      <p>
        [9] Raghu G, Remy‑Jardin M, Ryerson CJ, et al. Diagnosis of Hypersensitivity Pneumonitis in Adults. An Official ATS/JRS/ALAT Clinical Practice Guideline[J]. Am J Respir Crit Care Med, 2020, 202(3): e36‑e69. DOI: 10.1164/rccm.202005‑2032ST.
      </p>
      <p>
        [10] Vasakova M, Selman M, Morell F, et al. Hypersensitivity Pneumonitis: Current Concepts of Pathogenesis and Potential Targets for Treatment[J]. Am J Respir Crit Care Med, 2019, 200(3): 301‑308. DOI: 10.1164/rccm.201903‑0541PP.
      </p>
      <p>
        [11] Barnes H, Corte TJ, Keir G, et al. Diagnosis and management of hypersensitivity pneumonitis in adults: A position statement from the Thoracic Society of Australia and New Zealand[J]. Respirology, 2024, 29(12):1023‑1046. DOI: 10.1111/resp.14847.
      </p>
      <p>
        [12] Ryerson CJ, Corte TJ, Myers JL, et al. A contemporary practical approach to the multidisciplinary management of unclassifiable interstitial lung disease[J]. Eur Respir J, 2021,58(6):2100276. DOI: 10.1183/13993003.00276-2021.
      </p>
      <p>&nbsp;</p>
    </div>    
  </div>
</div>

<!-- 临床试验及研究进度-列表 -->
<div *ngIf="pages == 'home/lcsyjyjjd'" class="bg-fff">
  <div class="d-banner lcsyjyjjd-banner">
    <img src="./assets/new/jjzxfbypt_lcsy_banner.png" alt="">
    <div>
      当前位置：<a (click)="goDetails('home','首页')">首页</a> > <span>临床试验及研究进度</span>
    </div>
  </div>
  <div class="module-1 module-6 min-height500">
    <div id="carouselExampleIndicators6" class="carousel slide">
      <div class="study-list">
        <div class="widthB33 cursor-pointer" (click)="goDetails('lcsyjyjjdxq1','临床试验及研究进度')">
          <img src="./assets/new/jzxfbypt_home_lcsyjyjjd_ppf.png" width="150" class="d-block mb-2" alt="...">
          <div>
            <h5>进展性肺纤维化（PPF）中国前瞻性多中心登记研究</h5>
          </div>
        </div> 
        <div class="widthB33 cursor-pointer" (click)="goDetails('qgdzxqdh','全国多中心启动会议')">
          <img src="./assets/new/jzxfbypt_home_lcsyjyjjd_ppf2.png" width="150" class="d-block mb-2" alt="...">
          <div>
            <h5>全国多中心启动会议——进展性肺纤维化（PPF）中国前膽性多中心登记研究</h5>
          </div>
        </div> 
        <!-- <div class="widthB33 cursor-pointer">
          <img src="./assets/new/jzxfbypt_home_yjqyjz_tupian.png" width="150" class="d-block mb-2" alt="...">
          <div>
            <h5></h5>
          </div>
        </div>  -->
      </div>
    </div>
  </div>
</div>

<!-- 临床试验及研究进度-详情 -->
<div *ngIf="pages == 'home/lcsyjyjjdxq1'">
  <div class="d-banner lcsyjyjjd-banner">
    <img src="./assets/new/jjzxfbypt_lcsy_banner.png" alt="">
    <div>
      当前位置：<a (click)="goDetails('home','首页')">首页</a> > <a (click)="goDetails('lcsyjyjjd','首页')">临床试验及研究进度</a>
    </div>
  </div>
  <div class="bg-fff">

    <div class="hzkp-con">
      <div class="yjjd jzxfb">
        <img src="./assets/new/jjzxfbypt_lcsy_ic_1.png" alt="">
        <div>研究名称</div>
      </div>
   
      <img src="./assets/new/jjzxfbypt_lcsy_profina.png" alt="">
      <div class="yjjd jzxfb">
        <img src="./assets/new/jjzxfbypt_lcsy_ic_2.png" alt="">
        <div>研究背景</div>
      </div>
      <div>
        <p>进展性肺纤维化（Progressive Pulmonary Fibrosis，PPF）是近年来国际呼吸学界逐渐明确的一类疾病概念，指一组不同病因的间质性肺疾病（Interstitial Lung Diseases, ILDs），在一定时间内均表现出持续的肺纤维化进展。其核心特征是：症状（如咳嗽、活动后气促）持续恶化，肺功能逐年下降，高分辨率CT（HRCT）影像学上可见纤维化病灶的范围不断扩大。这种进展常常不可逆，最终导致患者劳动和生活能力严重受限，甚至过早死亡。<br><br></p>

        <p>PPF的病因高度多样，包括结缔组织病相关ILD（如类风湿关节炎、系统性硬化症相关ILD）、过敏性肺炎（HP）、非特异性间质性肺炎（NSIP）、特发性胸膜肺实质弹力纤维增生症（PPFE）、肉芽肿病、药物相关或职业/环境暴露导致的纤维化性ILD等。不同的起始疾病在早期临床特征和病理机制上各具特点，但一旦进入进展期，往往出现相似的临床轨迹：炎症与纤维化交织，肺泡结构破坏，纤维化呈“自我维持”状态，不同疾病最终趋同于以纤维化为主导的病程。这种“异病同归”的特性，使得PPF研究具有重要的跨疾病临床意义。<br><br></p>

        <p>
          国际大型队列研究（如INSIGHTS-ILD等）已揭示PPF在欧美患者中的疾病谱、危险因素和预后模式，例如持续抗原暴露、重度基础呼吸困难、双肺“撕裂样啰音”以及静息血氧饱和度降低等均与疾病快速进展相关。然而，目前中国尚缺乏大规模、前瞻性、多中心的真实世界登记研究，国内患者的临床特征、诊疗模式、疾病负担以及预后模式仍未得到系统揭示。<br><br>
        </p>
        <p>
          因此，本研究依托全国多家呼吸专科中心，计划建立首个中国PPF患者的前瞻性登记数据库，系统收集临床、影像、肺功能、治疗及生活质量等多维度信息，全面揭示我国PPF人群的流行病学特征与临床现状，为制定更符合国情的诊治策略、推动新药研发及早期干预提供关键科学依据。研究拟在全国约30家中心同步开展，预计入组600例患者，随访两年。<br><br>
        </p>
        <p>
          未来，将逐步扩展至更多中心，持续推动全国范围内的ILD登记性研究。依托由北京协和医院徐作军教授团队建设的“间质性肺病云平台”，参研中心的最新进展也将陆续对外发布，诚邀全国患者积极参与。<br>
        </p>
      </div>
      <div class="yjjd jzxfb">
        <img src="./assets/new/jjzxfbypt_lcsy_ic_2.png" alt="">
        <div>研究目的</div>
      </div>

      <div>
        <p>本研究是一项 前瞻性、多中心、观察性登记研究，不改变也不干预患者的常规治疗。主要目标是：</p>
      </div>
      <div>
        <p><span>•</span>	系统评估中国PPF患者在真实世界中的疾病进展情况（以FVC变化为核心指标）；</p>
        <p><span>•</span>	全面描绘PPF患者的临床特征、影像学表现、治疗方式和未满足的临床需求；</p>
        <p><span>•</span>	探索影响疾病预后的危险因素；</p>
        <p><span>•</span>	评估患者的疾病经济负担及非药物治疗现状；</p>
        <p><span>•</span> 开发基于咳嗽声音的疾病监测工具，用于预测肺功能和症状的变化。</p>
      </div>
      
      <div class="yjjd jzxfb">
        <img src="./assets/new/jjzxfbypt_lcsy_ic_3.png" alt="">
        <div>入选标准</div>
      </div>

      <div class="size-3 text-indent32">
        入组条件：
      </div>
      <div>
        <p><span>•</span>	年龄 ≥ 18岁；</p>
        <p><span>•</span>	在过去一年内符合PPF诊断标准；</p>
        <p><span>•</span>	签署知情同意书，自愿参加研究。</p>
      </div>
      
      <div class="size-3 text-indent32">
        <p>PPF诊断标准</p>
        <p>（2022 ATS/ERS/JRS/ALAT）：</p>
      </div>
      <div>
        <p>
          在非IPF的纤维化性ILD且影像学证实肺纤维化的患者中，如在过去一年内满足以下三条中的至少两条，且无其他原因可解释，即可诊断为PPF：
        </p>
      </div>
      <div>
        <p>	1. 呼吸道症状加重：如咳嗽、呼吸困难明显恶化；</p>
        <p>	2. 肺功能恶化：一年内FVC绝对下降 ≥5%，或DLCO下降 ≥10%（经血红蛋白校正）；</p>
        <p>	3. 影像学进展：包括但不限于：</p>
      </div>
      <div>
        <p><span>•</span>	牵拉性支气管扩张/周围性支气管扩张加重；</p>
        <p><span>•</span>	新发伴牵拉性支气管扩张的磨玻璃影；</p>
        <p><span>•</span>	新的或加重的网格状影；</p>
        <p><span>•</span>	蜂窝样改变新发或加重；</p>
        <p><span>•</span>	肺容积进一步缩小。</p>
      </div>

      <div class="yjjd jzxfb">
        <img src="./assets/new/jjzxfbypt_lcsy_ic_4.png" alt="">
        <div>排除条件</div>
      </div>
      <div>
        <p><span>•</span>	已确诊为特发性肺纤维化（IPF）；</p>
        <p><span>•</span> 缺乏基线胸部HRCT资料；</p>
        <p><span>•</span>	拒绝签署知情同意书；</p>
        <p><span>•</span>	正在参加其他药物临床试验（已结束或洗脱期满2周的可纳入）。</p>
      </div>

      
      <div class="yjjd jzxfb">
        <img src="./assets/new/jjzxfbypt_lcsy_ic_5.png" alt="">
        <div>患者收益与风险</div>
      </div>
      <div>
        本研究为观察性登记研究，不会干预或改变您的常规诊疗过程。参与研究的患者将在两年内接受系统的随访和评估，帮助医生更好地了解病情进展。同时，入组患者可获得一定的研究补助，用于交通与随访支出。研究过程中不会增加额外风险，所有检查均属于常规诊疗范围，您的个人信息将受到严格保护。
      </div>


      
      <div class="yjjd jzxfb">
        <img src="./assets/new/jjzxfbypt_lcsy_ic_6.png" alt="">
        <div>伦理与备案</div>
      </div>
      <div>
        <p><span>•</span> 本研究已通过中国医学科学院北京协和医院伦理委员会批准（伦理批件号：I-25PJ0893）；</p>
        <p><span>•</span> 已在国家医学研究登记系统备案（备案号：MR-11-25-032351）；</p>
        <p><span>•</span> 全过程将遵循《赫尔辛基宣言》和国家药物临床试验管理规范。</p>
      </div>


      <div class="yjjd jzxfb">
        <img src="./assets/new/jjzxfbypt_lcsy_ic_7.png" alt="">
        <div>联系方式</div>
      </div>
      <div>
        <p>
          如果您或您的家属符合条件并有意愿参与，请联系我们：
        </p>
        <p>
          中国医学科学院北京协和医院 呼吸与危重症医学科
        </p>
        <p>
          联系人：尹成胜<br><br>
        </p>
      </div>
      
    </div>
    
  </div>
</div>


<!-- 全国多中心启动会议——进展性肺纤维化（PPF）中国前膽性多中心登记研究-详情1 -->
<div *ngIf="pages == 'home/qgdzxqdh'" class="bg-fff">
  <div class="d-banner yjqyjz-banner">
    <img src="./assets/new/jzxfbypt_yjqyjz_tittle.png" alt="">
    <div>
      当前位置：<a (click)="goDetails('home','首页')">首页</a> > <a (click)="goDetails('yjqyjz','首页')">研究前沿进展</a>
    </div>
  </div>

  <div class="hzkp-con">
    <div class="size-2 text-indent0">
      全国多中心启动会议——进展性肺纤维化（PPF）中国前膽性多中心登记研究
    </div>
    <div class="size-3">
      内容简要
    </div>
    <div>
      2026年6月7日，进展性肺纤维化（PPF）中国前瞻性多中心登记研究（PROFINA）全国多中心线上启动会顺利召开。会议围绕研究方案、项目进度、数据平台、技术应用四大维度开展研讨，并设置专家讨论环节，保障研究高质量推进。
    </div>
    <div>
      本次研究由北京协和医院徐作军教授担任主要研究者，汇聚全国30余家分中心、40余名间质性肺病领域专家，同时集结CRO、SMO、数据平台、AI技术等多家合作企业团队，共同推进这项国内PPF领域重要的真实世界研究。
    </div>
    <img class="widthB80" src="./assets/new/hy_1.png" alt="">
    <div class="size-3">
      一、牵头专家致辞，阐明研究核心意义
    </div>
    <div>
      <p>徐作军教授在致辞中表示，PPF是一类病因多样、持续进展的难治性肺病，是呼吸领域重点研究方向。目前我国缺乏大规模前瞻性PPF研究数据，难以精准掌握国内患者的临床特征、治疗现状、经济负担及预后情况。</p>
      <p>本次研究在勃林格殷翰支持下，历经一年半筹备正式启动，联合全国30余家医院开展，计划10个月内入组600例患者，开展为期两年的随访。研究将系统收集患者临床、影像、肺功能数据，并创新性开展AI咳嗽音监测，探索咳嗽特征作为肺病进展、急性加重的生物标志物的临床价值。</p>
      <p>本研究为无干预真实世界观察性研究，旨在补充国内循证医学证据，助力国内PPF诊疗规范化。项目将为入组患者、研究医师提供专项补贴，并为各中心配备专职CRC，负责数据录入工作，减轻研究者负担，保障研究高效落地。</p>
      <p>徐教授同时表示欢迎各位间质性肺病专家共同参与开发、构建国内最全面的间质性肺病临床专病数据平台，并就如何评估贡献价值做了具体说明。</p>
    </div>
    <div class="size-3">
      二、研究方案系统解读
    </div>
    <div>
      <p>北京协和医院尹成胜老师详细解读PROFINA研究方案，从研究背景与目的、研究设计与入组人群、研究终点指标、随访计划与数据采集四大板块，明确了项目立题依据、入排标准、访视安排及数据采集质控要求。</p>     
    </div>
    <img class="widthB80" src="./assets/new/hy_2.png" alt="">

    <div class="size-3">
      三、项目进度与质量管理规划
    </div>
    <div>
      广州海博特项目经理周思君介绍，公司及旗下SMO子公司广州永利康负责本项目CRC派驻与全程质控，服务网络覆盖全国绝大多数区域。项目已于2025年9月启动首例入组，目前30多家分中心有序推进立项，8家已完成立项。项目预计2027年7月完成末例入组，2029年7月完成全部随访，同年10月出具研究总结报告。
    </div>
    <div>后续将针对CRA、研究者、CRC开展方案、操作规范、EDC系统、科研APP等专项培训，明确岗位职责，同时联动各中心PI推进项目落地，攻克实施难点。</div>
        
    <div class="size-3">
      四、数字化平台与AI技术赋能研究
    </div>
    <div>
      <p>
        北京康脉互联科技发展有限公司张振彪经理介绍了专属数据平台“间肺云APP”，平台由医生端、患者端、影像端多端组成，具备操作简便、数据互通、安全可追溯的特点，可满足临床试验数据采集与患者慢病管理双重需求，搭建专业化肺病科研与管理体系。
      </p>
      <p>
        Luka Health Care冯冠霖经理介绍了AI咳嗽音采集技术，团队依托AI算法提供数字化临床研究全流程服务，负责咳嗽音数据采集、存储、智能分析与质控。
      </p>
    </div>
    <img class="widthB80" src="./assets/new/hy_3.png" alt="">

    <div class="size-3">
      五、项目后续计划与会议总结
    </div>
    <div>
      会后加速各中心合同签署，搭建全国研究者交流群，由CRO整理会议纪要并统一项目执行标准。本次启动会的召开，标志着PROFINA研究正式进入实质性实施阶段，将以高质量真实世界数据，推动国内PPF诊疗规范化、精准化发展，优化患者疾病管理方案，为临床决策提供权威循证依据。
    </div>
    <img class="widthB80" src="./assets/new/hy_4.png" alt="">

    <div class="size-3">
      leading PI简介
    </div>
    <img class="width300 margin0auto" src="./assets/new/hy_5.png" alt="">
    <div>
      徐作军， 医学博士，北京协和医院呼吸与危重症医学科主任医师，教授，博士生导师。      
    </div>
    <div>
      担任中国研究型医院学会呼吸病专业委员会主任委员，中国老年医学学会呼吸病学分会副会长，中华医学会呼吸病分会第7-10届间质病学副组长等。
    </div>
    <div>
      重点研究方向是弥漫性间质性肺疾病、结节病、肺部感染和急性肺损伤等。主持和承担多项国家级研究课题和计划。曾获北京市科学技术进步一等奖1项，中华医学科技二等奖1项。在nature medicine等杂志发表研究成果200余篇。参加了39本专著的编写。牵头主持多项国内和国际肺纤维化新药临床研究
    </div>
    <div>&nbsp;</div>
  </div>
</div>


<!-- 资源下载 -->
<div *ngIf="pages == 'home/zyxz'">
  <div class="introduce-list bg-fff pt-30">
    <div class="container zyxzs-con">
      <div class="active" (click)="goDetails('zyxz')">
        <div><img src="./assets/new/jzxfbypt_home_zyxz_yjbg.png" alt=""></div>
        <div class="title">研究报告</div>
      </div>
      <div (click)="goDetails('bgygj')">
        <div><img src="./assets/new/jzxfbypt_home_zyxz_bggj.png" alt=""></div>
        <div class="title">表格与工具</div>
      </div>
      <div (click)="goDetails('wxsjk')">
        <div><img src="./assets/new/jzxfbypt_home_zyxz_wxsjk.png" alt=""></div>
        <div class="title">文献数据库</div>
      </div>
    </div>
  </div>

  <div class="download-list">
    <div class="container">
      <div>
        <img class="img1" src="./assets/fxwhweb_zyxz_btn_xz.png" alt="">
        <img class="img2" src="./assets/fxwhweb_zyxz_btn_xxbgxz.png" alt="">
        <div class="title">详细报告下载</div>
      </div>
      <div>
        <img class="img1" src="./assets/fxwhweb_zyxz_btn_xz.png" alt="">
        <img class="img2" src="./assets/fxwhweb_zyxz_btn_ndyjbgxz.png" alt="">
        <div class="title">年度研究报告下载</div>
      </div>
      <div>
        <img class="img1" src="./assets/fxwhweb_zyxz_btn_xz.png" alt="">
        <img class="img2" src="./assets/fxwhweb_zyxz_btn_lcysyjnr.png" alt="">
        <div class="title">专项研究报告</div>
      </div>
      <div>
        <img class="img1" src="./assets/fxwhweb_zyxz_btn_xz.png" alt="">
        <img class="img2" src="./assets/fxwhweb_zyxz_btn_kyryyjnr.png" alt="">
        <div class="title">科研人员研究内容</div>
      </div>
      <div>
        <img class="img1" src="./assets/fxwhweb_zyxz_btn_xz.png" alt="">
        <img class="img2" src="./assets/fxwhweb_zyxz_btn_lcysyjnr.png" alt="">
        <div class="title">临床医生研究内容</div>
      </div>
    </div>
  </div>
</div>

<!-- 表格与工具 -->
<div *ngIf="pages == 'home/bgygj'">  
  <div class="introduce-list bg-fff pt-30">
    <div class="container zyxzs-con">
      <div (click)="goDetails('zyxz')">
        <div><img src="./assets/new/jzxfbypt_home_zyxz_yjbg.png" alt=""></div>
        <div class="title">研究报告</div>
      </div>
      <div class="active" (click)="goDetails('bgygj')">
        <div><img src="./assets/new/jzxfbypt_home_zyxz_bggj.png" alt=""></div>
        <div class="title">表格与工具</div>
      </div>
      <div (click)="goDetails('wxsjk')">
        <div><img src="./assets/new/jzxfbypt_home_zyxz_wxsjk.png" alt=""></div>
        <div class="title">文献数据库</div>
      </div>
    </div>
  </div>
  
  <div class="download-list">
    <div class="container justify-content-center">
      <div>
        <img class="img1" src="./assets/fxwhweb_zyxz_btn_xz.png" alt="">
        <img class="img2" src="./assets/fxwhweb_zyxz_btn_kyryyjnr.png" alt="">
        <div class="title">患者信息采集表</div>
      </div>
      <div>
        <img class="img1" src="./assets/fxwhweb_zyxz_btn_xz.png" alt="">
        <img class="img2" src="./assets/fxwhweb_zyxz_btn_lcysyjnr.png" alt="">
        <div class="title">随访记录表</div>
      </div>
      <div class="jyb">
        <img class="img1" src="./assets/fxwhweb_zyxz_btn_xz.png" alt="">
        <img class="img2" src="./assets/fxwhweb_zyxz_btn_fgnpggjrj.png" alt="">
        <div class="title">肺功能评估工具软件（简易版）</div>
      </div>
    </div>
  </div>
</div>

<!-- 文献数据库 -->
<div *ngIf="pages == 'home/wxsjk'">
  <div class="introduce-list bg-fff pt-30">
    <div class="container zyxzs-con">
      <div (click)="goDetails('zyxz')">
        <div><img src="./assets/new/jzxfbypt_home_zyxz_yjbg.png" alt=""></div>
        <div class="title">研究报告</div>
      </div>
      <div (click)="goDetails('bgygj')">
        <div><img src="./assets/new/jzxfbypt_home_zyxz_bggj.png" alt=""></div>
        <div class="title">表格与工具</div>
      </div>
      <div class="active" (click)="goDetails('wxsjk')">
        <div><img src="./assets/new/jzxfbypt_home_zyxz_wxsjk.png" alt=""></div>
        <div class="title">文献数据库</div>
      </div>
    </div>
  </div>

  <div class="download-list">
    <div class="container literature">
      <div data-bs-toggle="modal" data-bs-target="#staticBackdrop">
        <img class="mx-2" src="./assets/fxwhweb_zyxz_ic_wx.png" alt="">
        <p>xxxxxxxxxxxxxxxxxx，xxxxxxxxxxxxxxxxxxxxxx，xxxxxxxxxxxxxxx</p>
      </div>
      <div data-bs-toggle="modal" data-bs-target="#staticBackdrop">
        <img class="mx-2" src="./assets/fxwhweb_zyxz_ic_wx.png" alt="">
        <p>xxxxxxxxxxxx，xxxxxxxxxxxxxxxxxxxxxxxxxxx，xxxxxxxxxxxxxxxx</p>
      </div>
      <div data-bs-toggle="modal" data-bs-target="#staticBackdrop">
        <img class="mx-2" src="./assets/fxwhweb_zyxz_ic_wx.png" alt="">
        <p>xxxxxxxxxxxxxxxxx，xxxxxxxxxxxxxxxxxxxxx，xxxxxxxxxxxxxxxxx</p>
      </div>
      <div data-bs-toggle="modal" data-bs-target="#staticBackdrop">
        <img class="mx-2" src="./assets/fxwhweb_zyxz_ic_wx.png" alt="">
        <p>xxxxxxxxxxxxx，xxxxxxxxxxxxxxxxxxxxxx，xxxxxxxxxxxxxxxxxxxx</p>
      </div>
      <div data-bs-toggle="modal" data-bs-target="#staticBackdrop">
        <img class="mx-2" src="./assets/fxwhweb_zyxz_ic_wx.png" alt="">
        <p>xxxxxxxxx，xxxxxxxxxxxxxxxxxx，xxxxxxxxxxxxxxxxxxx，xxxxxxxxx</p>
      </div>
      <div data-bs-toggle="modal" data-bs-target="#staticBackdrop">
        <img class="mx-2" src="./assets/fxwhweb_zyxz_ic_wx.png" alt="">
        <p>xxxxxxxxxx，xxxxxxxxxxxxxxx，xxxxxxxxxxxxxxxxxx，xxxxxxxxxxxx</p>
      </div>
      <div data-bs-toggle="modal" data-bs-target="#staticBackdrop">
        <img class="mx-2" src="./assets/fxwhweb_zyxz_ic_wx.png" alt="">
        <p>xxxxxxxxxxxxx，xxxxxxxxxxxxxxxxxxxxxx，xxxxxxxxxxxxxxxxxxxx</p>
      </div>
    </div>
  </div>
</div>

<!-- 资源下载-Modal -->
<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="staticBackdropLabel">pdf</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        ...
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">关闭</button>
        <button type="button" class="btn btn-primary">确定</button>
      </div>
    </div>
  </div>
</div>

<!-- 底部 -->
<div>
  <div class="footer-bg" *ngIf="pages == 'home/home'">
    <div class="lxwm">
      <img src="./assets/new/jzxfbypt_home_lxwm.png" alt="">
    </div>
    <div class="container">
      <div class="contact">
        <div class="d-flex">
          <div class="scan">
            <img class="mb-2" src="./assets/app.png" alt="">
            <p class="mb-0">App</p>
          </div>
          <div class="scan">
            <img class="mb-2" src="./assets/jianfeijiayuan.jpg" alt="">
            <p class="mb-0">间肺家园服务号</p>
          </div>
          <div class="scan">
            <img class="mb-2" src="./assets/jianfeiyun.jpg" alt="">
            <p class="mb-0">间肺云公众号</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="bg-dark">
  <div class="container">
    <div class="text-center text-white">
      技术支持：北京康迈互联科技发展有限公司<br>      
      电话：010-67309068  E-mail：service@healthbit.cn      
    </div>    
  </div>
</div>

<a href="#top"><img class="top-img" src="./assets/new/jzxfbypt_home_huidb.png" alt=""></a>
